(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './androidx-compose-runtime-runtime.js', './androidx-navigation3-navigation3-runtime.js', './androidx-lifecycle-lifecycle-common.js', './androidx-lifecycle-lifecycle-runtime-compose.js', './androidx-navigationevent-navigationevent.js', './compose-multiplatform-core-compose-ui-ui.js', './compose-multiplatform-core-compose-foundation-foundation-layout.js', './compose-multiplatform-core-navigationevent-navigationevent-compose.js', './compose-multiplatform-core-compose-animation-animation-core.js', './androidx-collection-collection.js', './compose-multiplatform-core-compose-animation-animation.js', './kotlinx-coroutines-core.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./androidx-compose-runtime-runtime.js'), require('./androidx-navigation3-navigation3-runtime.js'), require('./androidx-lifecycle-lifecycle-common.js'), require('./androidx-lifecycle-lifecycle-runtime-compose.js'), require('./androidx-navigationevent-navigationevent.js'), require('./compose-multiplatform-core-compose-ui-ui.js'), require('./compose-multiplatform-core-compose-foundation-foundation-layout.js'), require('./compose-multiplatform-core-navigationevent-navigationevent-compose.js'), require('./compose-multiplatform-core-compose-animation-animation-core.js'), require('./androidx-collection-collection.js'), require('./compose-multiplatform-core-compose-animation-animation.js'), require('./kotlinx-coroutines-core.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-navigation3-navigation3-ui'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'compose-multiplatform-core-navigation3-navigation3-ui'.");
    }
    if (typeof globalThis['androidx-compose-runtime-runtime'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-navigation3-navigation3-ui'. Its dependency 'androidx-compose-runtime-runtime' was not found. Please, check whether 'androidx-compose-runtime-runtime' is loaded prior to 'compose-multiplatform-core-navigation3-navigation3-ui'.");
    }
    if (typeof globalThis['androidx-navigation3-navigation3-runtime'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-navigation3-navigation3-ui'. Its dependency 'androidx-navigation3-navigation3-runtime' was not found. Please, check whether 'androidx-navigation3-navigation3-runtime' is loaded prior to 'compose-multiplatform-core-navigation3-navigation3-ui'.");
    }
    if (typeof globalThis['androidx-lifecycle-lifecycle-common'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-navigation3-navigation3-ui'. Its dependency 'androidx-lifecycle-lifecycle-common' was not found. Please, check whether 'androidx-lifecycle-lifecycle-common' is loaded prior to 'compose-multiplatform-core-navigation3-navigation3-ui'.");
    }
    if (typeof globalThis['androidx-lifecycle-lifecycle-runtime-compose'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-navigation3-navigation3-ui'. Its dependency 'androidx-lifecycle-lifecycle-runtime-compose' was not found. Please, check whether 'androidx-lifecycle-lifecycle-runtime-compose' is loaded prior to 'compose-multiplatform-core-navigation3-navigation3-ui'.");
    }
    if (typeof globalThis['androidx-navigationevent-navigationevent'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-navigation3-navigation3-ui'. Its dependency 'androidx-navigationevent-navigationevent' was not found. Please, check whether 'androidx-navigationevent-navigationevent' is loaded prior to 'compose-multiplatform-core-navigation3-navigation3-ui'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-navigation3-navigation3-ui'. Its dependency 'compose-multiplatform-core-compose-ui-ui' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui' is loaded prior to 'compose-multiplatform-core-navigation3-navigation3-ui'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-foundation-foundation-layout'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-navigation3-navigation3-ui'. Its dependency 'compose-multiplatform-core-compose-foundation-foundation-layout' was not found. Please, check whether 'compose-multiplatform-core-compose-foundation-foundation-layout' is loaded prior to 'compose-multiplatform-core-navigation3-navigation3-ui'.");
    }
    if (typeof globalThis['compose-multiplatform-core-navigationevent-navigationevent-compose'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-navigation3-navigation3-ui'. Its dependency 'compose-multiplatform-core-navigationevent-navigationevent-compose' was not found. Please, check whether 'compose-multiplatform-core-navigationevent-navigationevent-compose' is loaded prior to 'compose-multiplatform-core-navigation3-navigation3-ui'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-animation-animation-core'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-navigation3-navigation3-ui'. Its dependency 'compose-multiplatform-core-compose-animation-animation-core' was not found. Please, check whether 'compose-multiplatform-core-compose-animation-animation-core' is loaded prior to 'compose-multiplatform-core-navigation3-navigation3-ui'.");
    }
    if (typeof globalThis['androidx-collection-collection'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-navigation3-navigation3-ui'. Its dependency 'androidx-collection-collection' was not found. Please, check whether 'androidx-collection-collection' is loaded prior to 'compose-multiplatform-core-navigation3-navigation3-ui'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-animation-animation'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-navigation3-navigation3-ui'. Its dependency 'compose-multiplatform-core-compose-animation-animation' was not found. Please, check whether 'compose-multiplatform-core-compose-animation-animation' is loaded prior to 'compose-multiplatform-core-navigation3-navigation3-ui'.");
    }
    if (typeof globalThis['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-navigation3-navigation3-ui'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'compose-multiplatform-core-navigation3-navigation3-ui'.");
    }
    globalThis['compose-multiplatform-core-navigation3-navigation3-ui'] = factory(typeof globalThis['compose-multiplatform-core-navigation3-navigation3-ui'] === 'undefined' ? {} : globalThis['compose-multiplatform-core-navigation3-navigation3-ui'], globalThis['kotlin-kotlin-stdlib'], globalThis['androidx-compose-runtime-runtime'], globalThis['androidx-navigation3-navigation3-runtime'], globalThis['androidx-lifecycle-lifecycle-common'], globalThis['androidx-lifecycle-lifecycle-runtime-compose'], globalThis['androidx-navigationevent-navigationevent'], globalThis['compose-multiplatform-core-compose-ui-ui'], globalThis['compose-multiplatform-core-compose-foundation-foundation-layout'], globalThis['compose-multiplatform-core-navigationevent-navigationevent-compose'], globalThis['compose-multiplatform-core-compose-animation-animation-core'], globalThis['androidx-collection-collection'], globalThis['compose-multiplatform-core-compose-animation-animation'], globalThis['kotlinx-coroutines-core']);
  }
}(function (_, kotlin_kotlin, kotlin_androidx_compose_runtime_runtime, kotlin_androidx_navigation3_navigation3_runtime, kotlin_androidx_lifecycle_lifecycle_common, kotlin_androidx_lifecycle_lifecycle_runtime_compose, kotlin_androidx_navigationevent_navigationevent, kotlin_org_jetbrains_compose_ui_ui, kotlin_org_jetbrains_compose_foundation_foundation_layout, kotlin_org_jetbrains_androidx_navigationevent_navigationevent_compose, kotlin_org_jetbrains_compose_animation_animation_core, kotlin_androidx_collection_collection, kotlin_org_jetbrains_compose_animation_animation, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var Collection = kotlin_kotlin.$_$.y6;
  var isInterface = kotlin_kotlin.$_$.rg;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var RandomAccess = kotlin_kotlin.$_$.m7;
  var rememberUpdatedState = kotlin_androidx_compose_runtime_runtime.$_$.g2;
  var rememberComposableLambda = kotlin_androidx_compose_runtime_runtime.$_$.c;
  var Companion_getInstance = kotlin_androidx_compose_runtime_runtime.$_$.w2;
  var VOID = kotlin_kotlin.$_$.d;
  var NavEntryDecorator = kotlin_androidx_navigation3_navigation3_runtime.$_$.a;
  var KProperty0 = kotlin_kotlin.$_$.xi;
  var getLocalDelegateReference = kotlin_kotlin.$_$.wf;
  var equals = kotlin_kotlin.$_$.sf;
  var constructCallableReference = kotlin_kotlin.$_$.of;
  var State_CREATED_getInstance = kotlin_androidx_lifecycle_lifecycle_common.$_$.k;
  var State_RESUMED_getInstance = kotlin_androidx_lifecycle_lifecycle_common.$_$.n;
  var rememberLifecycleOwner = kotlin_androidx_lifecycle_lifecycle_runtime_compose.$_$.b;
  var get_LocalLifecycleOwner = kotlin_androidx_lifecycle_lifecycle_runtime_compose.$_$.a;
  var androidx_compose_runtime_ProvidedValue$stableprop_getter = kotlin_androidx_compose_runtime_runtime.$_$.f1;
  var CompositionLocalProvider = kotlin_androidx_compose_runtime_runtime.$_$.l;
  var protoOf = kotlin_kotlin.$_$.eh;
  var initMetadataForInterface = kotlin_kotlin.$_$.gg;
  var lastOrNull = kotlin_kotlin.$_$.ka;
  var emptyMap = kotlin_kotlin.$_$.d9;
  var objectCreate = kotlin_kotlin.$_$.dh;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var NavigationEventInfo = kotlin_androidx_navigationevent_navigationevent.$_$.b;
  var getKClassFromExpression = kotlin_kotlin.$_$.ri;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var hashCode = kotlin_kotlin.$_$.bg;
  var toString = kotlin_kotlin.$_$.hh;
  var movableContentOf = kotlin_androidx_compose_runtime_runtime.$_$.u1;
  var mutableStateMapOf = kotlin_androidx_compose_runtime_runtime.$_$.a2;
  var composableLambdaInstance = kotlin_androidx_compose_runtime_runtime.$_$.b;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  var HashSet_init_$Create$ = kotlin_kotlin.$_$.g4;
  var compositionLocalOf = kotlin_androidx_compose_runtime_runtime.$_$.i1;
  var emptyList = kotlin_kotlin.$_$.c9;
  var listOfNotNull = kotlin_kotlin.$_$.ra;
  var rememberDecoratedNavEntries = kotlin_androidx_navigation3_navigation3_runtime.$_$.e;
  var toList = kotlin_kotlin.$_$.kc;
  var mutableListOf = kotlin_kotlin.$_$.cb;
  var last = kotlin_kotlin.$_$.na;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.p5;
  var dropLast = kotlin_kotlin.$_$.a9;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.z3;
  var first = kotlin_kotlin.$_$.o9;
  var firstOrNull = kotlin_kotlin.$_$.k9;
  var Companion_instance = kotlin_org_jetbrains_compose_ui_ui.$_$.ec;
  var Companion_getInstance_0 = kotlin_org_jetbrains_compose_ui_ui.$_$.dc;
  var maybeCachedBoxMeasurePolicy = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.v;
  var get_currentCompositeKeyHashCode = kotlin_androidx_compose_runtime_runtime.$_$.l1;
  var materialize = kotlin_org_jetbrains_compose_ui_ui.$_$.wa;
  var Companion_getInstance_1 = kotlin_org_jetbrains_compose_ui_ui.$_$.vb;
  var invalidApplier = kotlin_androidx_compose_runtime_runtime.$_$.r1;
  var Applier = kotlin_androidx_compose_runtime_runtime.$_$.h;
  var _Updater___init__impl__rbfxm8 = kotlin_androidx_compose_runtime_runtime.$_$.r2;
  var Updater__set_impl_v7kwss = kotlin_androidx_compose_runtime_runtime.$_$.t2;
  var Updater__reconcile_impl_1mfi6g = kotlin_androidx_compose_runtime_runtime.$_$.s2;
  var BoxScopeInstance_instance = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.b2;
  var listOf = kotlin_kotlin.$_$.sa;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var rememberSaveableStateHolderNavEntryDecorator = kotlin_androidx_navigation3_navigation3_runtime.$_$.f;
  var rememberDecoratedNavEntries_0 = kotlin_androidx_navigation3_navigation3_runtime.$_$.d;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.b8;
  var rememberNavigationEventState = kotlin_org_jetbrains_androidx_navigationevent_navigationevent_compose.$_$.b;
  var NavigationBackHandler = kotlin_org_jetbrains_androidx_navigationevent_navigationevent_compose.$_$.a;
  var SeekableTransitionState = kotlin_org_jetbrains_compose_animation_animation_core.$_$.o;
  var androidx_compose_animation_core_SeekableTransitionState$stableprop_getter = kotlin_org_jetbrains_compose_animation_animation_core.$_$.h1;
  var rememberTransition = kotlin_org_jetbrains_compose_animation_animation_core.$_$.w1;
  var InProgress = kotlin_androidx_navigationevent_navigationevent.$_$.e;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.uo;
  var Idle = kotlin_androidx_navigationevent_navigationevent.$_$.d;
  var mutableObjectFloatMapOf = kotlin_androidx_collection_collection.$_$.e1;
  var SnapshotStateList_init_$Create$ = kotlin_androidx_compose_runtime_runtime.$_$.a3;
  var LaunchedEffect = kotlin_androidx_compose_runtime_runtime.$_$.r;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.j4;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.a4;
  var sortedWith = kotlin_kotlin.$_$.yb;
  var plus = kotlin_kotlin.$_$.ib;
  var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.m4;
  var toSet = kotlin_kotlin.$_$.tc;
  var toMutableSet = kotlin_kotlin.$_$.sc;
  var emptySet = kotlin_kotlin.$_$.e9;
  var LaunchedEffect_0 = kotlin_androidx_compose_runtime_runtime.$_$.s;
  var AnimatedContent = kotlin_org_jetbrains_compose_animation_animation.$_$.a;
  var createCompositionCoroutineScope = kotlin_androidx_compose_runtime_runtime.$_$.k1;
  var State_STARTED_getInstance = kotlin_androidx_lifecycle_lifecycle_common.$_$.o;
  var getValue = kotlin_kotlin.$_$.u9;
  var throwUninitializedPropertyAccessException = kotlin_kotlin.$_$.ce;
  var CompositionLocalProvider_0 = kotlin_androidx_compose_runtime_runtime.$_$.k;
  var launch = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.q3;
  var get_indices = kotlin_kotlin.$_$.z9;
  var get = kotlin_androidx_navigation3_navigation3_runtime.$_$.c;
  var FunctionAdapter = kotlin_kotlin.$_$.cf;
  var Comparator = kotlin_kotlin.$_$.bn;
  var removeLastOrNull = kotlin_kotlin.$_$.nb;
  var KtMutableList = kotlin_kotlin.$_$.i7;
  var updateChangedFlags = kotlin_androidx_compose_runtime_runtime.$_$.q2;
  var CoroutineImpl = kotlin_kotlin.$_$.xd;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.y2;
  var initMetadataForLambda = kotlin_kotlin.$_$.hg;
  var compareValues = kotlin_kotlin.$_$.ad;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.gd;
  var fromInt = kotlin_kotlin.$_$.pe;
  var divide = kotlin_kotlin.$_$.ne;
  var toNumber = kotlin_kotlin.$_$.bf;
  var numberToInt = kotlin_kotlin.$_$.ch;
  var to = kotlin_kotlin.$_$.ip;
  var tween = kotlin_org_jetbrains_compose_animation_animation_core.$_$.z1;
  var animate = kotlin_org_jetbrains_compose_animation_animation_core.$_$.e2;
  var ContentTransform = kotlin_org_jetbrains_compose_animation_animation.$_$.d;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.eg;
  var FlowCollector = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.p1;
  var Flow = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.q1;
  var Long = kotlin_kotlin.$_$.kn;
  var bitwiseAnd = kotlin_kotlin.$_$.ge;
  var compare = kotlin_kotlin.$_$.je;
  var shiftRight = kotlin_kotlin.$_$.ze;
  var invert = kotlin_kotlin.$_$.qe;
  var shiftLeft = kotlin_kotlin.$_$.xe;
  var equalsLong = kotlin_kotlin.$_$.oe;
  var snapshotFlow = kotlin_androidx_compose_runtime_runtime.$_$.h2;
  var EmptyCoroutineContext_getInstance = kotlin_kotlin.$_$.q2;
  var Companion_getInstance_2 = kotlin_org_jetbrains_compose_animation_animation.$_$.v;
  var Companion_getInstance_3 = kotlin_org_jetbrains_compose_animation_animation.$_$.w;
  //endregion
  //region block: pre-declaration
  function get_metadata() {
    var tmp0_safe_receiver = lastOrNull(this.s1());
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.umu_1;
    return tmp1_elvis_lhs == null ? emptyMap() : tmp1_elvis_lhs;
  }
  initMetadataForInterface(Scene, 'Scene');
  function onRemove($completion) {
    return Unit_instance;
  }
  initMetadataForInterface(OverlayScene, 'OverlayScene', VOID, VOID, [Scene], [0]);
  initMetadataForClass(SceneStrategyScope, 'SceneStrategyScope', SceneStrategyScope_init_$Create$);
  initMetadataForClass(SceneDecoratorStrategyScope, 'SceneDecoratorStrategyScope', SceneDecoratorStrategyScope_init_$Create$, SceneStrategyScope);
  initMetadataForClass(SceneInfo, 'SceneInfo', VOID, NavigationEventInfo);
  initMetadataForClass(SceneSetupNavEntryDecorator, 'SceneSetupNavEntryDecorator', SceneSetupNavEntryDecorator, NavEntryDecorator);
  initMetadataForObject(ComposableSingletons$SceneSetupNavEntryDecoratorKt, 'ComposableSingletons$SceneSetupNavEntryDecoratorKt');
  initMetadataForClass(SceneState, 'SceneState');
  initMetadataForClass(SharedEntryInSceneNavEntryDecorator, 'SharedEntryInSceneNavEntryDecorator', VOID, NavEntryDecorator);
  initMetadataForClass(SinglePaneSceneStrategy, 'SinglePaneSceneStrategy', SinglePaneSceneStrategy);
  initMetadataForClass(SinglePaneScene, 'SinglePaneScene', VOID, VOID, [Scene]);
  initMetadataForClass(AnimatedSceneKey, 'AnimatedSceneKey');
  initMetadataForObject(TransitionKey, 'TransitionKey');
  initMetadataForObject(PopTransitionKey, 'PopTransitionKey');
  initMetadataForObject(PredictivePopTransitionKey, 'PredictivePopTransitionKey');
  initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  initMetadataForLambda(NavDisplay$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(NavDisplay$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(NavDisplay$slambda$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(NavDisplay$slambda_3, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(NavDisplay$slambda$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$, CoroutineImpl);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForClass(NavDisplay$$inlined$cache$10$2, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForLambda(NavDisplay$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(NavDisplay$slambda_5, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(NavDisplay$slambda_7, CoroutineImpl, VOID, [1]);
  //endregion
  function fastAnyOrAny(_this__u8e3s4, predicate) {
    var tmp;
    if (isInterface(_this__u8e3s4, RandomAccess)) {
      var tmp$ret$0;
      $l$block: {
        // Inline function 'androidx.navigation3.fastAny' call
        // Inline function 'androidx.navigation3.fastForEach' call
        var inductionVariable = 0;
        var last = _this__u8e3s4.n1() - 1 | 0;
        if (inductionVariable <= last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var item = _this__u8e3s4.l1(index);
            if (predicate(item)) {
              tmp$ret$0 = true;
              break $l$block;
            }
          }
           while (inductionVariable <= last);
        tmp$ret$0 = false;
      }
      tmp = tmp$ret$0;
    } else {
      var tmp$ret$3;
      $l$block_1: {
        // Inline function 'kotlin.collections.any' call
        var tmp_0;
        if (isInterface(_this__u8e3s4, Collection)) {
          tmp_0 = _this__u8e3s4.r();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$3 = false;
          break $l$block_1;
        }
        var _iterator__ex2g4s = _this__u8e3s4.t();
        while (_iterator__ex2g4s.u()) {
          var element = _iterator__ex2g4s.v();
          if (predicate(element)) {
            tmp$ret$3 = true;
            break $l$block_1;
          }
        }
        tmp$ret$3 = false;
      }
      tmp = tmp$ret$3;
    }
    return tmp;
  }
  function rememberBackStackAwareLifecycleNavEntryDecorator(entries, $composer, $changed) {
    var $composer_0 = $composer;
    var updatedEntries$delegate = rememberUpdatedState(entries, $composer_0, 14 & $changed);
    // Inline function 'kotlin.run' call
    var dispatchReceiver = rememberComposableLambda(1077673004, true, rememberBackStackAwareLifecycleNavEntryDecorator$lambda_0(updatedEntries$delegate), $composer_0, 54);
    // Inline function 'androidx.compose.runtime.remember' call
    var $composer_1 = $composer_0;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = $composer_1.k31(dispatchReceiver);
    // Inline function 'kotlin.let' call
    var it = $composer_1.i31();
    var tmp;
    if (invalid || it === Companion_getInstance().f30_1) {
      var value = ComposableLambda$invoke$ref_0(dispatchReceiver);
      $composer_1.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var tmp$ret$0 = tmp;
    return new NavEntryDecorator(VOID, tmp$ret$0);
  }
  function rememberBackStackAwareLifecycleNavEntryDecorator$lambda($updatedEntries$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('updatedEntries', KProperty0, false);
    return $updatedEntries$delegate.u1();
  }
  function rememberBackStackAwareLifecycleNavEntryDecorator$lambda$lambda($entry) {
    return function (it) {
      return equals(it.tmu_1, $entry.tmu_1);
    };
  }
  function rememberBackStackAwareLifecycleNavEntryDecorator$lambda$lambda_0($entry) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        $entry.cmv($composer_0, 0);
        tmp = Unit_instance;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ComposableLambda$invoke$ref(p0) {
    return constructCallableReference(function (p0_0, p1) {
      p0.t50(p0_0, p1);
      return Unit_instance;
    }, 2, 0, 17, VOID, [p0]);
  }
  function rememberBackStackAwareLifecycleNavEntryDecorator$lambda_0($updatedEntries$delegate) {
    return function (entry, $composer, $changed) {
      var $composer_0 = $composer;
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ($composer_0.k31(entry) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
        var tmp_1 = rememberBackStackAwareLifecycleNavEntryDecorator$lambda($updatedEntries$delegate);
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = ($dirty & 14) === 4;
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_2;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = rememberBackStackAwareLifecycleNavEntryDecorator$lambda$lambda(entry);
          $composer_0.j31(value);
          tmp_2 = value;
        } else {
          tmp_2 = it;
        }
        var tmp$ret$0 = tmp_2;
        var isInBackStack = fastAnyOrAny(tmp_1, tmp$ret$0);
        var maxLifecycle = isInBackStack ? State_RESUMED_getInstance() : State_CREATED_getInstance();
        var owner = rememberLifecycleOwner(maxLifecycle, null, $composer_0, 0, 2);
        var tmp_3 = get_LocalLifecycleOwner().h3c(owner);
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(-1713684244, true, rememberBackStackAwareLifecycleNavEntryDecorator$lambda$lambda_0(entry), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_1.i31();
        var tmp_4;
        if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
          var value_0 = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_1.j31(value_0);
          tmp_4 = value_0;
        } else {
          tmp_4 = it_0;
        }
        var tmp$ret$4 = tmp_4;
        CompositionLocalProvider(tmp_3, tmp$ret$4, $composer_0, 48 | androidx_compose_runtime_ProvidedValue$stableprop_getter());
        tmp_0 = Unit_instance;
      } else {
        $composer_0.z30();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ComposableLambda$invoke$ref_0(p0) {
    return constructCallableReference(function (p0_0, p1, p2) {
      p0.u50(p0_0, p1, p2);
      return Unit_instance;
    }, 3, 0, 18, VOID, [p0]);
  }
  var androidx_navigation3_scene_DialogScene$stable;
  var androidx_navigation3_scene_DialogSceneStrategy_Companion_DialogKey$stable;
  var androidx_navigation3_scene_DialogSceneStrategy$stable;
  function OverlayScene() {
  }
  function Scene() {
  }
  var androidx_navigation3_scene_SceneDecoratorStrategyScope$stable;
  function SceneDecoratorStrategyScope_init_$Init$($this) {
    SceneDecoratorStrategyScope.call($this, SceneDecoratorStrategyScope$_init_$lambda_d2l51j);
    return $this;
  }
  function SceneDecoratorStrategyScope_init_$Create$() {
    return SceneDecoratorStrategyScope_init_$Init$(objectCreate(protoOf(SceneDecoratorStrategyScope)));
  }
  function SceneDecoratorStrategyScope$_init_$lambda_d2l51j() {
    return Unit_instance;
  }
  function SceneDecoratorStrategyScope(onBack) {
    SceneStrategyScope.call(this, onBack);
  }
  var androidx_navigation3_scene_SceneInfo$stable;
  function SceneInfo(scene) {
    NavigationEventInfo.call(this);
    this.fxq_1 = scene;
  }
  protoOf(SceneInfo).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof SceneInfo))
      THROW_CCE();
    return equals(this.fxq_1, other.fxq_1);
  };
  protoOf(SceneInfo).hashCode = function () {
    return hashCode(this.fxq_1);
  };
  protoOf(SceneInfo).toString = function () {
    return 'SceneInfo(scene=' + toString(this.fxq_1) + ')';
  };
  function get_LocalEntriesToExcludeFromCurrentScene() {
    _init_properties_SceneSetupNavEntryDecorator_kt__hhbh49();
    return LocalEntriesToExcludeFromCurrentScene;
  }
  var LocalEntriesToExcludeFromCurrentScene;
  var androidx_navigation3_scene_SceneSetupNavEntryDecorator$stable;
  function SceneSetupNavEntryDecorator$_init_$lambda_jpepxs($movableContentMap) {
    return function (contentKey) {
      $movableContentMap.a3(contentKey);
      return Unit_instance;
    };
  }
  function ComposableLambda$invoke$ref_1(p0) {
    return constructCallableReference(function (p0_0, p1, p2) {
      p0.u50(p0_0, p1, p2);
      return Unit_instance;
    }, 3, 0, 18, VOID, [p0]);
  }
  function SceneSetupNavEntryDecorator$_init_$lambda$lambda_9dwkit($entry) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        $entry.cmv($composer_0, 0);
        tmp = Unit_instance;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SceneSetupNavEntryDecorator$_init_$lambda_jpepxs_0($movableContentMap) {
    return function (entry, $composer, $changed) {
      var $composer_0 = $composer;
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ($composer_0.k31(entry) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
        var contentKey = entry.tmu_1;
        // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
        var this_0 = get_LocalEntriesToExcludeFromCurrentScene();
        var $composer_1 = $composer_0;
        var entriesToExclude = $composer_1.u31(this_0);
        var tmp_1;
        if (!entriesToExclude.m1(contentKey)) {
          $composer_0.m30(1574916499);
          $composer_0.o30(1159182959, contentKey);
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it = $composer_0.i31();
          var tmp_2;
          if (false || it === Companion_getInstance().f30_1) {
            // Inline function 'kotlin.collections.getOrPut' call
            var this_1 = $movableContentMap;
            var value = this_1.w2(contentKey);
            var tmp_3;
            if (value == null) {
              var answer = movableContentOf(ComposableSingletons$SceneSetupNavEntryDecoratorKt_getInstance().gxq_1);
              this_1.z2(contentKey, answer);
              tmp_3 = answer;
            } else {
              tmp_3 = value;
            }
            var value_0 = tmp_3;
            $composer_0.j31(value_0);
            tmp_2 = value_0;
          } else {
            tmp_2 = it;
          }
          var movableContent = tmp_2;
          // Inline function 'kotlin.run' call
          var dispatchReceiver = rememberComposableLambda(-804085656, true, SceneSetupNavEntryDecorator$_init_$lambda$lambda_9dwkit(entry), $composer_0, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_2 = $composer_0;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid = $composer_2.k31(dispatchReceiver);
          // Inline function 'kotlin.let' call
          var it_0 = $composer_2.i31();
          var tmp_4;
          if (invalid || it_0 === Companion_getInstance().f30_1) {
            var value_1 = ComposableLambda$invoke$ref(dispatchReceiver);
            $composer_2.j31(value_1);
            tmp_4 = value_1;
          } else {
            tmp_4 = it_0;
          }
          movableContent(tmp_4, $composer_0, 54);
          $composer_0.p30();
          $composer_0.n30();
          tmp_1 = Unit_instance;
        } else {
          $composer_0.m30(1576267665);
          $composer_0.n30();
          tmp_1 = Unit_instance;
        }
        tmp_0 = tmp_1;
      } else {
        $composer_0.z30();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SceneSetupNavEntryDecorator(movableContentMap) {
    movableContentMap = movableContentMap === VOID ? mutableStateMapOf() : movableContentMap;
    var tmp = SceneSetupNavEntryDecorator$_init_$lambda_jpepxs(movableContentMap);
    NavEntryDecorator.call(this, tmp, ComposableLambda$invoke$ref_1(composableLambdaInstance(-1714993007, true, SceneSetupNavEntryDecorator$_init_$lambda_jpepxs_0(movableContentMap))));
    this.jxq_1 = movableContentMap;
  }
  function rememberSceneSetupNavEntryDecorator($composer, $changed) {
    _init_properties_SceneSetupNavEntryDecorator_kt__hhbh49();
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.cache' call
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (false || it === Companion_getInstance().f30_1) {
      var value = new SceneSetupNavEntryDecorator();
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    return tmp;
  }
  function ComposableLambda$invoke$ref_2(p0) {
    return constructCallableReference(function (p0_0, p1, p2) {
      p0.u50(p0_0, p1, p2);
      return Unit_instance;
    }, 3, 0, 18, VOID, [p0]);
  }
  function ComposableSingletons$SceneSetupNavEntryDecoratorKt$lambda$_51699941$lambda_q5i8b4(content, $composer, $changed) {
    var $composer_0 = $composer;
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 4 : 2);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      content($composer_0, 14 & $dirty);
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$SceneSetupNavEntryDecoratorKt() {
    ComposableSingletons$SceneSetupNavEntryDecoratorKt_instance = this;
    var tmp = this;
    tmp.gxq_1 = ComposableLambda$invoke$ref_2(composableLambdaInstance(-51699941, false, ComposableSingletons$SceneSetupNavEntryDecoratorKt$lambda$_51699941$lambda_q5i8b4));
  }
  var ComposableSingletons$SceneSetupNavEntryDecoratorKt_instance;
  function ComposableSingletons$SceneSetupNavEntryDecoratorKt_getInstance() {
    if (ComposableSingletons$SceneSetupNavEntryDecoratorKt_instance == null)
      new ComposableSingletons$SceneSetupNavEntryDecoratorKt();
    return ComposableSingletons$SceneSetupNavEntryDecoratorKt_instance;
  }
  function LocalEntriesToExcludeFromCurrentScene$lambda() {
    _init_properties_SceneSetupNavEntryDecorator_kt__hhbh49();
    return HashSet_init_$Create$();
  }
  var properties_initialized_SceneSetupNavEntryDecorator_kt_obldgr;
  function _init_properties_SceneSetupNavEntryDecorator_kt__hhbh49() {
    if (!properties_initialized_SceneSetupNavEntryDecorator_kt_obldgr) {
      properties_initialized_SceneSetupNavEntryDecorator_kt_obldgr = true;
      LocalEntriesToExcludeFromCurrentScene = compositionLocalOf(VOID, LocalEntriesToExcludeFromCurrentScene$lambda);
      androidx_navigation3_scene_SceneSetupNavEntryDecorator$stable = 0;
    }
  }
  var androidx_navigation3_scene_SceneState$stable;
  function SceneState(entries, overlayScenes, currentScene, previousScenes) {
    this.kxq_1 = entries;
    this.lxq_1 = overlayScenes;
    this.mxq_1 = currentScene;
    this.nxq_1 = previousScenes;
  }
  protoOf(SceneState).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof SceneState))
      THROW_CCE();
    return equals(this.kxq_1, other.kxq_1) && equals(this.lxq_1, other.lxq_1) && equals(this.mxq_1, other.mxq_1) && equals(this.nxq_1, other.nxq_1);
  };
  protoOf(SceneState).hashCode = function () {
    return ((imul(hashCode(this.kxq_1), 31) + imul(hashCode(this.lxq_1), 31) | 0) + imul(hashCode(this.mxq_1), 31) | 0) + imul(hashCode(this.nxq_1), 31) | 0;
  };
  protoOf(SceneState).toString = function () {
    return 'SceneState(entries=' + toString(this.kxq_1) + ', overlayScenes=' + toString(this.lxq_1) + ', currentScene=' + toString(this.mxq_1) + ', previousScenes=' + toString(this.nxq_1) + ')';
  };
  function rememberSceneState(entries, sceneStrategies, sceneDecoratorStrategies, sharedTransitionScope, onBack, $composer, $changed, $default) {
    var sceneDecoratorStrategies_0 = sceneDecoratorStrategies;
    var sharedTransitionScope_0 = sharedTransitionScope;
    var $composer_0 = $composer;
    if (!(($default & 4) === 0))
      sceneDecoratorStrategies_0 = emptyList();
    if (!(($default & 8) === 0))
      sharedTransitionScope_0 = null;
    var currentOnBack$delegate = rememberUpdatedState(onBack, $composer_0, 14 & $changed >> 12);
    var tmp0_safe_receiver = sharedTransitionScope_0;
    var tmp;
    if (tmp0_safe_receiver == null) {
      $composer_0.m30(-984503628);
      $composer_0.n30();
      tmp = null;
    } else {
      $composer_0.m30(-984503627);
      // Inline function 'kotlin.let' call
      var tmp2_group = rememberSharedEntryInSceneNavEntryDecorator(tmp0_safe_receiver, $composer_0, 0);
      $composer_0.n30();
      tmp = tmp2_group;
    }
    var sharedElementDecorator = tmp;
    var decoratedEntries = rememberDecoratedNavEntries(entries, listOfNotNull([sharedElementDecorator, rememberSceneSetupNavEntryDecorator($composer_0, 0), rememberBackStackAwareLifecycleNavEntryDecorator(entries, $composer_0, 14 & $changed)]), $composer_0, 14 & $changed, 0);
    var tmp3_remember$arg$0 = toList(sceneStrategies);
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!($composer_0.k31(tmp3_remember$arg$0) | $composer_0.k31(decoratedEntries));
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp_0;
    if (invalid || it === Companion_getInstance().f30_1) {
      var scope = new SceneDecoratorStrategyScope(rememberSceneState$lambda_0(currentOnBack$delegate));
      var allScenes = mutableListOf([provideScene(scope, decoratedEntries, sceneStrategies, sceneDecoratorStrategies_0)]);
      do {
        var tmp_1 = last(allScenes);
        var overlayScene = isInterface(tmp_1, OverlayScene) ? tmp_1 : null;
        var overlaidEntries = overlayScene == null ? null : overlayScene.bxq();
        if (!(overlaidEntries == null)) {
          // Inline function 'kotlin.collections.isNotEmpty' call
          // Inline function 'kotlin.require' call
          if (!!overlaidEntries.r()) {
            var message = 'Overlaid entries from ' + toString(overlayScene) + ' must not be empty';
            throw IllegalArgumentException_init_$Create$(toString(message));
          }
          // Inline function 'kotlin.collections.plusAssign' call
          var element = provideScene(scope, overlaidEntries, sceneStrategies, sceneDecoratorStrategies_0);
          allScenes.j1(element);
        }
      }
       while (!(overlaidEntries == null));
      // Inline function 'androidx.compose.ui.util.fastMap' call
      var this_0 = dropLast(allScenes, 1);
      var target = ArrayList_init_$Create$(this_0.n1());
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last_0 = this_0.n1() - 1 | 0;
      if (inductionVariable <= last_0)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = this_0.l1(index);
          // Inline function 'kotlin.collections.plusAssign' call
          var element_0 = isInterface(item, OverlayScene) ? item : THROW_CCE();
          target.j1(element_0);
        }
         while (inductionVariable <= last_0);
      var overlayScenes = target;
      var currentScene = last(allScenes);
      var previousScenes = mutableListOf([first(allScenes)]);
      $l$1: do {
        $l$0: do {
          var previousScene = firstOrNull(previousScenes);
          var previousEntries = previousScene == null ? null : previousScene.dxq();
          // Inline function 'kotlin.collections.isNullOrEmpty' call
          var this_1 = previousEntries;
          if (!(this_1 == null || this_1.r())) {
            previousScenes.g3(0, provideScene(scope, previousEntries, sceneStrategies, sceneDecoratorStrategies_0));
          }
        }
         while (false);
        // Inline function 'kotlin.collections.isNullOrEmpty' call
        var this_2 = previousEntries;
        var tmp$ret$16 = this_2 == null || this_2.r();
      }
       while (!tmp$ret$16);
      previousScenes.d3(currentScene);
      var value = new SceneState(decoratedEntries, overlayScenes, currentScene, previousScenes);
      $composer_0.j31(value);
      tmp_0 = value;
    } else {
      tmp_0 = it;
    }
    return tmp_0;
  }
  function provideScene(scope, decoratedEntries, sceneStrategies, sceneDecorators) {
    // Inline function 'androidx.compose.ui.util.fastFold' call
    var accumulator = calculateSceneWithSinglePaneFallback(sceneStrategies, scope, decoratedEntries);
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = sceneDecorators.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = sceneDecorators.l1(index);
        var scene = accumulator;
        var tmp0_elvis_lhs = isInterface(scene, OverlayScene) ? scene : null;
        accumulator = tmp0_elvis_lhs == null ? decorateScene(item, scope, scene) : tmp0_elvis_lhs;
      }
       while (inductionVariable <= last);
    return accumulator;
  }
  function rememberSceneState$lambda($currentOnBack$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('currentOnBack', KProperty0, false);
    return $currentOnBack$delegate.u1();
  }
  function rememberSceneState$lambda_0($currentOnBack$delegate) {
    return function () {
      rememberSceneState$lambda($currentOnBack$delegate)();
      return Unit_instance;
    };
  }
  var androidx_navigation3_scene_SceneStrategyScope$stable;
  function SceneStrategyScope_init_$Init$($this) {
    SceneStrategyScope.call($this, SceneStrategyScope$_init_$lambda_rnrceu);
    return $this;
  }
  function SceneStrategyScope_init_$Create$() {
    return SceneStrategyScope_init_$Init$(objectCreate(protoOf(SceneStrategyScope)));
  }
  function SceneStrategyScope$_init_$lambda_rnrceu() {
    return Unit_instance;
  }
  function SceneStrategyScope(onBack) {
    this.oxq_1 = onBack;
  }
  function get_LocalCurrentScene() {
    _init_properties_SharedEntryInSceneNavEntryDecorator_kt__yge400();
    return LocalCurrentScene;
  }
  var LocalCurrentScene;
  var androidx_navigation3_scene_SharedEntryInSceneNavEntryDecorator$stable;
  function ComposableLambda$invoke$ref_3(p0) {
    return constructCallableReference(function (p0_0, p1, p2) {
      p0.u50(p0_0, p1, p2);
      return Unit_instance;
    }, 3, 0, 18, VOID, [p0]);
  }
  function SharedEntryInSceneNavEntryDecorator$_init_$lambda_kqc9sp($sharedTransitionScope) {
    return function (entry, $composer, $changed) {
      var $composer_0 = $composer;
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ($composer_0.k31(entry) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
        // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
        var this_0 = get_LocalCurrentScene();
        var $composer_1 = $composer_0;
        var currentScene = $composer_1.u31(this_0);
        var tmp_1;
        var tmp_2;
        if (!(currentScene == null)) {
          tmp_2 = !isInterface(currentScene, OverlayScene);
        } else {
          tmp_2 = false;
        }
        if (tmp_2) {
          $composer_0.m30(-1924421295);
          // Inline function 'kotlin.with' call
          var $this$with = $sharedTransitionScope;
          var tmp_3 = Companion_instance;
          var tmp_4 = $this$with.yf9(entry.tmu_1, $composer_0, 0);
          // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
          var this_1 = get_LocalNavAnimatedContentScope();
          var $composer_2 = $composer_0;
          var tmp$ret$3 = $composer_2.u31(this_1);
          // Inline function 'androidx.compose.foundation.layout.Box' call
          var modifier = $this$with.wf9(tmp_3, tmp_4, tmp$ret$3);
          var contentAlignment = null;
          var propagateMinConstraints = false;
          var $composer_3 = $composer_0;
          if (!((6 & 1) === 0))
            modifier = Companion_instance;
          if (!((6 & 2) === 0))
            contentAlignment = Companion_getInstance_0().k8t_1;
          if (!((6 & 4) === 0))
            propagateMinConstraints = false;
          var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_0 = modifier;
          var $composer_4 = $composer_3;
          if (!((0 & 2) === 0))
            modifier_0 = Companion_instance;
          var compositeKeyHash = get_currentCompositeKeyHashCode($composer_4, 0).hashCode();
          var localMap = $composer_4.t31();
          var materialized = materialize($composer_4, modifier_0);
          var tmp0 = Companion_getInstance_1().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_5 = $composer_4;
          var tmp_5 = $composer_5.g30();
          if (!isInterface(tmp_5, Applier)) {
            invalidApplier();
          }
          $composer_5.b31();
          if ($composer_5.h30()) {
            $composer_5.c31(tmp0);
          } else {
            $composer_5.d31();
          }
          var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_5);
          Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_1().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_1().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_1().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_1().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_1().qah_1);
          var $composer_6 = $composer_5;
          var $composer_7 = $composer_6;
          entry.cmv($composer_7, 14 & $dirty);
          $composer_5.e31();
          $composer_0.n30();
          tmp_1 = Unit_instance;
        } else {
          $composer_0.m30(-1924000656);
          entry.cmv($composer_0, 14 & $dirty);
          $composer_0.n30();
          tmp_1 = Unit_instance;
        }
        tmp_0 = tmp_1;
      } else {
        $composer_0.z30();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SharedEntryInSceneNavEntryDecorator(sharedTransitionScope) {
    NavEntryDecorator.call(this, VOID, ComposableLambda$invoke$ref_3(composableLambdaInstance(2108709411, true, SharedEntryInSceneNavEntryDecorator$_init_$lambda_kqc9sp(sharedTransitionScope))));
  }
  function rememberSharedEntryInSceneNavEntryDecorator(sharedTransitionScope, $composer, $changed) {
    _init_properties_SharedEntryInSceneNavEntryDecorator_kt__yge400();
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = ($changed & 14 ^ 6) > 4 && $composer_0.k31(sharedTransitionScope) || ($changed & 6) === 4;
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance().f30_1) {
      var value = new SharedEntryInSceneNavEntryDecorator(sharedTransitionScope);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    return tmp;
  }
  function LocalCurrentScene$lambda() {
    _init_properties_SharedEntryInSceneNavEntryDecorator_kt__yge400();
    return null;
  }
  var properties_initialized_SharedEntryInSceneNavEntryDecorator_kt_y031pa;
  function _init_properties_SharedEntryInSceneNavEntryDecorator_kt__yge400() {
    if (!properties_initialized_SharedEntryInSceneNavEntryDecorator_kt_y031pa) {
      properties_initialized_SharedEntryInSceneNavEntryDecorator_kt_y031pa = true;
      LocalCurrentScene = compositionLocalOf(VOID, LocalCurrentScene$lambda);
      androidx_navigation3_scene_SharedEntryInSceneNavEntryDecorator$stable = 0;
    }
  }
  var androidx_navigation3_scene_SinglePaneScene$stable;
  var androidx_navigation3_scene_SinglePaneSceneStrategy$stable;
  function SinglePaneSceneStrategy() {
  }
  protoOf(SinglePaneSceneStrategy).pxq = function (_this__u8e3s4, entries) {
    return new SinglePaneScene(last(entries).tmu_1, last(entries), dropLast(entries, 1));
  };
  function SinglePaneScene$content$lambda(this$0) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        this$0.rxq_1.cmv($composer_0, 0);
        tmp = Unit_instance;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SinglePaneScene(key, entry, previousEntries) {
    this.qxq_1 = key;
    this.rxq_1 = entry;
    this.sxq_1 = previousEntries;
    this.txq_1 = listOf(this.rxq_1);
    var tmp = this;
    tmp.uxq_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-322904035, true, SinglePaneScene$content$lambda(this)));
  }
  protoOf(SinglePaneScene).t1 = function () {
    return this.qxq_1;
  };
  protoOf(SinglePaneScene).dxq = function () {
    return this.sxq_1;
  };
  protoOf(SinglePaneScene).s1 = function () {
    return this.txq_1;
  };
  protoOf(SinglePaneScene).rj3 = function () {
    return this.uxq_1;
  };
  protoOf(SinglePaneScene).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof SinglePaneScene))
      THROW_CCE();
    return equals(this.qxq_1, other.qxq_1) && this.rxq_1.equals(other.rxq_1) && equals(this.sxq_1, other.sxq_1) && equals(this.txq_1, other.txq_1);
  };
  protoOf(SinglePaneScene).hashCode = function () {
    return ((imul(hashCode(this.qxq_1), 31) + imul(this.rxq_1.hashCode(), 31) | 0) + imul(hashCode(this.sxq_1), 31) | 0) + imul(hashCode(this.txq_1), 31) | 0;
  };
  protoOf(SinglePaneScene).toString = function () {
    return 'SinglePaneScene(key=' + toString(this.qxq_1) + ', entry=' + this.rxq_1.toString() + ', previousEntries=' + toString(this.sxq_1) + ', entries=' + toString(this.txq_1) + ')';
  };
  function calculateSceneWithSinglePaneFallback(sceneStrategies, scope, entries) {
    var scene = null;
    var inductionVariable = 0;
    var last = sceneStrategies.n1() - 1 | 0;
    if (inductionVariable <= last)
      $l$loop: do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.with' call
        scene = sceneStrategies.l1(index).pxq(scope, entries);
      }
       while (scene == null && inductionVariable <= last);
    var tmp0_elvis_lhs = scene;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.with' call
      tmp = (new SinglePaneSceneStrategy()).pxq(scope, entries);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function decorateScene(_this__u8e3s4, scope, scene) {
    return _this__u8e3s4.vxq(scope, scene);
  }
  function get_LocalNavAnimatedContentScope() {
    _init_properties_LocalNavAnimatedContentScope_kt__vokuei();
    return LocalNavAnimatedContentScope;
  }
  var LocalNavAnimatedContentScope;
  function LocalNavAnimatedContentScope$lambda() {
    _init_properties_LocalNavAnimatedContentScope_kt__vokuei();
    throw IllegalStateException_init_$Create$('Unexpected access to LocalNavAnimatedContentScope. You should only access LocalNavAnimatedContentScope inside a NavEntry passed to NavDisplay. AnimatedContentScope in OverlayScenes are no-op.');
  }
  var properties_initialized_LocalNavAnimatedContentScope_kt_yojgmw;
  function _init_properties_LocalNavAnimatedContentScope_kt__vokuei() {
    if (!properties_initialized_LocalNavAnimatedContentScope_kt_yojgmw) {
      properties_initialized_LocalNavAnimatedContentScope_kt_yojgmw = true;
      LocalNavAnimatedContentScope = compositionLocalOf(VOID, LocalNavAnimatedContentScope$lambda);
    }
  }
  var androidx_navigation3_ui_NavDisplay_TransitionKey$stable;
  var androidx_navigation3_ui_NavDisplay_PopTransitionKey$stable;
  var androidx_navigation3_ui_NavDisplay_PredictivePopTransitionKey$stable;
  var androidx_navigation3_ui_NavDisplay$stable;
  var androidx_navigation3_ui_AnimatedSceneKey$stable;
  function NavDisplay(backStack, modifier, contentAlignment, onBack, entryDecorators, sceneStrategies, sceneDecoratorStrategies, sharedTransitionScope, sizeTransform, transitionSpec, popTransitionSpec, predictivePopTransitionSpec, entryProvider, $composer, $changed, $changed1, $default) {
    var modifier_0 = {_v: modifier};
    var contentAlignment_0 = {_v: contentAlignment};
    var onBack_0 = {_v: onBack};
    var entryDecorators_0 = {_v: entryDecorators};
    var sceneStrategies_0 = {_v: sceneStrategies};
    var sceneDecoratorStrategies_0 = {_v: sceneDecoratorStrategies};
    var sharedTransitionScope_0 = {_v: sharedTransitionScope};
    var sizeTransform_0 = {_v: sizeTransform};
    var transitionSpec_0 = {_v: transitionSpec};
    var popTransitionSpec_0 = {_v: popTransitionSpec};
    var predictivePopTransitionSpec_0 = {_v: predictivePopTransitionSpec};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1398581072);
    var $dirty = $changed;
    var $dirty1 = $changed1;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(backStack) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(contentAlignment_0._v) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | (($default & 8) === 0 && $composer_0.q31(onBack_0._v) ? 2048 : 1024);
    if (($changed & 24576) === 0)
      $dirty = $dirty | (($default & 16) === 0 && $composer_0.q31(entryDecorators_0._v) ? 16384 : 8192);
    if (($changed & 196608) === 0)
      $dirty = $dirty | (($default & 32) === 0 && $composer_0.q31(sceneStrategies_0._v) ? 131072 : 65536);
    if (!(($default & 64) === 0))
      $dirty = $dirty | 1572864;
    else if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.q31(sceneDecoratorStrategies_0._v) ? 1048576 : 524288);
    if (!(($default & 128) === 0))
      $dirty = $dirty | 12582912;
    else if (($changed & 12582912) === 0)
      $dirty = $dirty | ($composer_0.k31(sharedTransitionScope_0._v) ? 8388608 : 4194304);
    if (!(($default & 256) === 0))
      $dirty = $dirty | 100663296;
    else if (($changed & 100663296) === 0)
      $dirty = $dirty | ($composer_0.q31(sizeTransform_0._v) ? 67108864 : 33554432);
    if (($changed & 805306368) === 0)
      $dirty = $dirty | (($default & 512) === 0 && $composer_0.q31(transitionSpec_0._v) ? 536870912 : 268435456);
    if (($changed1 & 6) === 0)
      $dirty1 = $dirty1 | (($default & 1024) === 0 && $composer_0.q31(popTransitionSpec_0._v) ? 4 : 2);
    if (($changed1 & 48) === 0)
      $dirty1 = $dirty1 | (($default & 2048) === 0 && $composer_0.q31(predictivePopTransitionSpec_0._v) ? 32 : 16);
    if (($changed1 & 384) === 0)
      $dirty1 = $dirty1 | ($composer_0.q31(entryProvider) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 306783379) === 306783378) || !(($dirty1 & 147) === 146), $dirty & 1)) {
      $composer_0.q30();
      if (($changed & 1) === 0 || $composer_0.j30()) {
        if (!(($default & 2) === 0)) {
          modifier_0._v = Companion_instance;
        }
        if (!(($default & 4) === 0)) {
          contentAlignment_0._v = Companion_getInstance_0().k8t_1;
        }
        if (!(($default & 8) === 0)) {
          var tmp0 = $composer_0;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid = $composer_0.q31(backStack);
          // Inline function 'kotlin.let' call
          var it = tmp0.i31();
          var tmp;
          if (invalid || it === Companion_getInstance().f30_1) {
            var value = NavDisplay$lambda(backStack);
            tmp0.j31(value);
            tmp = value;
          } else {
            tmp = it;
          }
          onBack_0._v = tmp;
          $dirty = $dirty & -7169;
        }
        if (!(($default & 16) === 0)) {
          entryDecorators_0._v = listOf(rememberSaveableStateHolderNavEntryDecorator(null, $composer_0, 0, 1));
          $dirty = $dirty & -57345;
        }
        if (!(($default & 32) === 0)) {
          sceneStrategies_0._v = listOf(new SinglePaneSceneStrategy());
          $dirty = $dirty & -458753;
        }
        if (!(($default & 64) === 0)) {
          sceneDecoratorStrategies_0._v = emptyList();
        }
        if (!(($default & 128) === 0)) {
          sharedTransitionScope_0._v = null;
        }
        if (!(($default & 256) === 0)) {
          sizeTransform_0._v = null;
        }
        if (!(($default & 512) === 0)) {
          transitionSpec_0._v = defaultTransitionSpec();
          $dirty = $dirty & -1879048193;
        }
        if (!(($default & 1024) === 0)) {
          popTransitionSpec_0._v = defaultPopTransitionSpec();
          $dirty1 = $dirty1 & -15;
        }
        if (!(($default & 2048) === 0)) {
          predictivePopTransitionSpec_0._v = defaultPredictivePopTransitionSpec();
          $dirty1 = $dirty1 & -113;
        }
      } else {
        $composer_0.z30();
        if (!(($default & 8) === 0))
          $dirty = $dirty & -7169;
        if (!(($default & 16) === 0))
          $dirty = $dirty & -57345;
        if (!(($default & 32) === 0))
          $dirty = $dirty & -458753;
        if (!(($default & 512) === 0))
          $dirty = $dirty & -1879048193;
        if (!(($default & 1024) === 0))
          $dirty1 = $dirty1 & -15;
        if (!(($default & 2048) === 0))
          $dirty1 = $dirty1 & -113;
      }
      $composer_0.r30();
      // Inline function 'kotlin.collections.isNotEmpty' call
      // Inline function 'kotlin.require' call
      if (!!backStack.r()) {
        var message = 'NavDisplay backstack cannot be empty';
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
      var entries = rememberDecoratedNavEntries_0(backStack, entryDecorators_0._v, entryProvider, $composer_0, 14 & $dirty | 112 & $dirty >> 9 | 896 & $dirty1, 0);
      NavDisplay_0(entries, modifier_0._v, contentAlignment_0._v, sceneStrategies_0._v, sceneDecoratorStrategies_0._v, sharedTransitionScope_0._v, sizeTransform_0._v, transitionSpec_0._v, popTransitionSpec_0._v, predictivePopTransitionSpec_0._v, onBack_0._v, $composer_0, 112 & $dirty | 896 & $dirty | 7168 & $dirty >> 6 | 57344 & $dirty >> 6 | 458752 & $dirty >> 6 | 3670016 & $dirty >> 6 | 29360128 & $dirty >> 6 | 234881024 & $dirty1 << 24 | 1879048192 & $dirty1 << 24, 14 & $dirty >> 9, 0);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(NavDisplay$lambda_0(backStack, modifier_0, contentAlignment_0, onBack_0, entryDecorators_0, sceneStrategies_0, sceneDecoratorStrategies_0, sharedTransitionScope_0, sizeTransform_0, transitionSpec_0, popTransitionSpec_0, predictivePopTransitionSpec_0, entryProvider, $changed, $changed1, $default));
    }
  }
  function NavDisplay_0(entries, modifier, contentAlignment, sceneStrategies, sceneDecoratorStrategies, sharedTransitionScope, sizeTransform, transitionSpec, popTransitionSpec, predictivePopTransitionSpec, onBack, $composer, $changed, $changed1, $default) {
    var modifier_0 = {_v: modifier};
    var contentAlignment_0 = {_v: contentAlignment};
    var sceneStrategies_0 = {_v: sceneStrategies};
    var sceneDecoratorStrategies_0 = {_v: sceneDecoratorStrategies};
    var sharedTransitionScope_0 = {_v: sharedTransitionScope};
    var sizeTransform_0 = {_v: sizeTransform};
    var transitionSpec_0 = {_v: transitionSpec};
    var popTransitionSpec_0 = {_v: popTransitionSpec};
    var predictivePopTransitionSpec_0 = {_v: predictivePopTransitionSpec};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1914095277);
    var $dirty = $changed;
    var $dirty1 = $changed1;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(entries) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(contentAlignment_0._v) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | (($default & 8) === 0 && $composer_0.q31(sceneStrategies_0._v) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.q31(sceneDecoratorStrategies_0._v) ? 16384 : 8192);
    if (!(($default & 32) === 0))
      $dirty = $dirty | 196608;
    else if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.k31(sharedTransitionScope_0._v) ? 131072 : 65536);
    if (!(($default & 64) === 0))
      $dirty = $dirty | 1572864;
    else if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.q31(sizeTransform_0._v) ? 1048576 : 524288);
    if (($changed & 12582912) === 0)
      $dirty = $dirty | (($default & 128) === 0 && $composer_0.q31(transitionSpec_0._v) ? 8388608 : 4194304);
    if (($changed & 100663296) === 0)
      $dirty = $dirty | (($default & 256) === 0 && $composer_0.q31(popTransitionSpec_0._v) ? 67108864 : 33554432);
    if (($changed & 805306368) === 0)
      $dirty = $dirty | (($default & 512) === 0 && $composer_0.q31(predictivePopTransitionSpec_0._v) ? 536870912 : 268435456);
    if (($changed1 & 6) === 0)
      $dirty1 = $dirty1 | ($composer_0.q31(onBack) ? 4 : 2);
    if ($composer_0.r31(!(($dirty & 306783379) === 306783378) || !(($dirty1 & 3) === 2), $dirty & 1)) {
      $composer_0.q30();
      if (($changed & 1) === 0 || $composer_0.j30()) {
        if (!(($default & 2) === 0)) {
          modifier_0._v = Companion_instance;
        }
        if (!(($default & 4) === 0)) {
          contentAlignment_0._v = Companion_getInstance_0().k8t_1;
        }
        if (!(($default & 8) === 0)) {
          sceneStrategies_0._v = listOf(new SinglePaneSceneStrategy());
          $dirty = $dirty & -7169;
        }
        if (!(($default & 16) === 0)) {
          sceneDecoratorStrategies_0._v = emptyList();
        }
        if (!(($default & 32) === 0)) {
          sharedTransitionScope_0._v = null;
        }
        if (!(($default & 64) === 0)) {
          sizeTransform_0._v = null;
        }
        if (!(($default & 128) === 0)) {
          transitionSpec_0._v = defaultTransitionSpec();
          $dirty = $dirty & -29360129;
        }
        if (!(($default & 256) === 0)) {
          popTransitionSpec_0._v = defaultPopTransitionSpec();
          $dirty = $dirty & -234881025;
        }
        if (!(($default & 512) === 0)) {
          predictivePopTransitionSpec_0._v = defaultPredictivePopTransitionSpec();
          $dirty = $dirty & -1879048193;
        }
      } else {
        $composer_0.z30();
        if (!(($default & 8) === 0))
          $dirty = $dirty & -7169;
        if (!(($default & 128) === 0))
          $dirty = $dirty & -29360129;
        if (!(($default & 256) === 0))
          $dirty = $dirty & -234881025;
        if (!(($default & 512) === 0))
          $dirty = $dirty & -1879048193;
      }
      $composer_0.r30();
      // Inline function 'kotlin.collections.isNotEmpty' call
      // Inline function 'kotlin.require' call
      if (!!entries.r()) {
        var message = 'NavDisplay entries cannot be empty';
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
      var sceneState = rememberSceneState(entries, sceneStrategies_0._v, sceneDecoratorStrategies_0._v, sharedTransitionScope_0._v, onBack, $composer_0, 14 & $dirty | 112 & $dirty >> 6 | 896 & $dirty >> 6 | 7168 & $dirty >> 6 | 57344 & $dirty1 << 12, 0);
      var scene = sceneState.mxq_1;
      var currentInfo = new SceneInfo(scene);
      // Inline function 'kotlin.collections.map' call
      var this_0 = sceneState.nxq_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
      var _iterator__ex2g4s = this_0.t();
      while (_iterator__ex2g4s.u()) {
        var item = _iterator__ex2g4s.v();
        var tmp$ret$5 = new SceneInfo(item);
        destination.j1(tmp$ret$5);
      }
      var previousSceneInfos = destination;
      var gestureState = rememberNavigationEventState(currentInfo, previousSceneInfos, null, $composer_0, 0, 4);
      // Inline function 'kotlin.collections.isNotEmpty' call
      var tmp = !scene.dxq().r();
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!(!!($composer_0.q31(entries) | $composer_0.k31(scene)) | ($dirty1 & 14) === 4);
      // Inline function 'kotlin.let' call
      var it = tmp0.i31();
      var tmp_0;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = NavDisplay$lambda_1(entries, scene, onBack);
        tmp0.j31(value);
        tmp_0 = value;
      } else {
        tmp_0 = it;
      }
      var tmp$ret$7 = tmp_0;
      NavigationBackHandler(gestureState, tmp, null, tmp$ret$7, $composer_0, 0, 4);
      NavDisplay_1(sceneState, gestureState, modifier_0._v, contentAlignment_0._v, sizeTransform_0._v, transitionSpec_0._v, popTransitionSpec_0._v, predictivePopTransitionSpec_0._v, $composer_0, 896 & $dirty << 3 | 7168 & $dirty << 3 | 57344 & $dirty >> 6 | 458752 & $dirty >> 6 | 3670016 & $dirty >> 6 | 29360128 & $dirty >> 6, 0);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(NavDisplay$lambda_2(entries, modifier_0, contentAlignment_0, sceneStrategies_0, sceneDecoratorStrategies_0, sharedTransitionScope_0, sizeTransform_0, transitionSpec_0, popTransitionSpec_0, predictivePopTransitionSpec_0, onBack, $changed, $changed1, $default));
    }
  }
  function NavDisplay_1(sceneState, navigationEventState, modifier, contentAlignment, sizeTransform, transitionSpec, popTransitionSpec, predictivePopTransitionSpec, $composer, $changed, $default) {
    var modifier_0 = {_v: modifier};
    var contentAlignment_0 = {_v: contentAlignment};
    var sizeTransform_0 = {_v: sizeTransform};
    var transitionSpec_0 = {_v: transitionSpec};
    var popTransitionSpec_0 = {_v: popTransitionSpec};
    var predictivePopTransitionSpec_0 = {_v: predictivePopTransitionSpec};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-303833701);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(sceneState) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(navigationEventState) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(contentAlignment_0._v) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.q31(sizeTransform_0._v) ? 16384 : 8192);
    if (($changed & 196608) === 0)
      $dirty = $dirty | (($default & 32) === 0 && $composer_0.q31(transitionSpec_0._v) ? 131072 : 65536);
    if (($changed & 1572864) === 0)
      $dirty = $dirty | (($default & 64) === 0 && $composer_0.q31(popTransitionSpec_0._v) ? 1048576 : 524288);
    if (($changed & 12582912) === 0)
      $dirty = $dirty | (($default & 128) === 0 && $composer_0.q31(predictivePopTransitionSpec_0._v) ? 8388608 : 4194304);
    if ($composer_0.r31(!(($dirty & 4793491) === 4793490), $dirty & 1)) {
      $composer_0.q30();
      if (($changed & 1) === 0 || $composer_0.j30()) {
        if (!(($default & 4) === 0)) {
          modifier_0._v = Companion_instance;
        }
        if (!(($default & 8) === 0)) {
          contentAlignment_0._v = Companion_getInstance_0().k8t_1;
        }
        if (!(($default & 16) === 0)) {
          sizeTransform_0._v = null;
        }
        if (!(($default & 32) === 0)) {
          transitionSpec_0._v = defaultTransitionSpec();
          $dirty = $dirty & -458753;
        }
        if (!(($default & 64) === 0)) {
          popTransitionSpec_0._v = defaultPopTransitionSpec();
          $dirty = $dirty & -3670017;
        }
        if (!(($default & 128) === 0)) {
          predictivePopTransitionSpec_0._v = defaultPredictivePopTransitionSpec();
          $dirty = $dirty & -29360129;
        }
      } else {
        $composer_0.z30();
        if (!(($default & 32) === 0))
          $dirty = $dirty & -458753;
        if (!(($default & 64) === 0))
          $dirty = $dirty & -3670017;
        if (!(($default & 128) === 0))
          $dirty = $dirty & -29360129;
      }
      $composer_0.r30();
      var scene = sceneState.mxq_1;
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp;
      if (false || it === Companion_getInstance().f30_1) {
        var value = new SeekableTransitionState(scene);
        this_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var transitionState = tmp;
      var transition = rememberTransition(transitionState, 'scene', $composer_0, 48 | androidx_compose_animation_core_SeekableTransitionState$stableprop_getter(), 0);
      var tmp0_remember$arg$0 = transition.v70();
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_0.k31(tmp0_remember$arg$0);
      // Inline function 'kotlin.let' call
      var it_0 = tmp0.i31();
      var tmp_0;
      if (invalid || it_0 === Companion_getInstance().f30_1) {
        var value_0 = toList(sceneState.kxq_1);
        tmp0.j31(value_0);
        tmp_0 = value_0;
      } else {
        tmp_0 = it_0;
      }
      var transitionCurrentStateEntries = tmp_0;
      var previousScene = lastOrNull(sceneState.nxq_1);
      var gestureTransition = navigationEventState.xxp();
      var tmp_1;
      if (gestureTransition instanceof InProgress) {
        tmp_1 = !(previousScene == null);
      } else {
        tmp_1 = false;
      }
      var inPredictiveBack = tmp_1;
      var tmp_2;
      if (gestureTransition instanceof Idle) {
        tmp_2 = 0.0;
      } else {
        if (gestureTransition instanceof InProgress) {
          tmp_2 = gestureTransition.s8p_1.q8m_1;
        } else {
          noWhenBranchMatchedException();
        }
      }
      var progress = tmp_2;
      var tmp_3;
      if (gestureTransition instanceof Idle) {
        tmp_3 = 2;
      } else {
        if (gestureTransition instanceof InProgress) {
          tmp_3 = gestureTransition.s8p_1.p8m_1;
        } else {
          noWhenBranchMatchedException();
        }
      }
      var swipeEdge = tmp_3;
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(collectionSizeOrDefault(transitionCurrentStateEntries, 10));
      var _iterator__ex2g4s = transitionCurrentStateEntries.t();
      while (_iterator__ex2g4s.u()) {
        var item = _iterator__ex2g4s.v();
        var tmp$ret$10 = item.tmu_1;
        destination.j1(tmp$ret$10);
      }
      var tmp_4 = destination;
      // Inline function 'kotlin.collections.map' call
      var this_1 = sceneState.kxq_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
      var _iterator__ex2g4s_0 = this_1.t();
      while (_iterator__ex2g4s_0.u()) {
        var item_0 = _iterator__ex2g4s_0.v();
        var tmp$ret$13 = item_0.tmu_1;
        destination_0.j1(tmp$ret$13);
      }
      var isPop_0 = isPop(tmp_4, destination_0);
      // Inline function 'androidx.compose.runtime.cache' call
      var this_2 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_1 = this_2.i31();
      var tmp_5;
      if (false || it_1 === Companion_getInstance().f30_1) {
        var value_1 = mutableStateMapOf();
        this_2.j31(value_1);
        tmp_5 = value_1;
      } else {
        tmp_5 = it_1;
      }
      var sceneMap = tmp_5;
      // Inline function 'androidx.compose.runtime.cache' call
      var this_3 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_2 = this_3.i31();
      var tmp_6;
      if (false || it_2 === Companion_getInstance().f30_1) {
        var value_2 = mutableObjectFloatMapOf();
        this_3.j31(value_2);
        tmp_6 = value_2;
      } else {
        tmp_6 = it_2;
      }
      var zIndices = tmp_6;
      var initialKey = AnimatedSceneKey_init_$Create$(transition.v70());
      var targetKey = AnimatedSceneKey_init_$Create$(transition.o70());
      var tmp$ret$22;
      $l$block: {
        // Inline function 'androidx.collection.MutableObjectFloatMap.getOrPut' call
        var index = zIndices.cz(initialKey);
        if (index >= 0) {
          tmp$ret$22 = zIndices.sy_1[index];
          break $l$block;
        }
        var value_3 = 0.0;
        zIndices.bz(initialKey, value_3);
        tmp$ret$22 = value_3;
      }
      var initialZIndex = tmp$ret$22;
      var tmp_7;
      var tmp_8;
      if (!inPredictiveBack && !equals(transition.o70(), scene)) {
        // Inline function 'androidx.collection.ObjectFloatMap.contains' call
        tmp_8 = zIndices.u2(targetKey);
      } else {
        tmp_8 = false;
      }
      if (tmp_8) {
        tmp_7 = zIndices.w2(targetKey);
      } else {
        if (initialKey.equals(targetKey)) {
          tmp_7 = initialZIndex;
        } else {
          if (isPop_0 || inPredictiveBack) {
            tmp_7 = initialZIndex - 1.0;
          } else {
            tmp_7 = initialZIndex + 1.0;
          }
        }
      }
      var targetZIndex = tmp_7;
      // Inline function 'kotlin.collections.set' call
      var value_4 = transition.o70();
      sceneMap.z2(targetKey, value_4);
      zIndices.bz(targetKey, targetZIndex);
      var overlayScenes = sceneState.lxq_1;
      // Inline function 'androidx.compose.runtime.cache' call
      var this_4 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_3 = this_4.i31();
      var tmp_9;
      if (false || it_3 === Companion_getInstance().f30_1) {
        var value_5 = SnapshotStateList_init_$Create$();
        this_4.j31(value_5);
        tmp_9 = value_5;
      } else {
        tmp_9 = it_3;
      }
      var currentOverlayScenes = tmp_9;
      var tmp0_0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = $composer_0.q31(overlayScenes);
      // Inline function 'kotlin.let' call
      var it_4 = tmp0_0.i31();
      var tmp_10;
      if (invalid_0 || it_4 === Companion_getInstance().f30_1) {
        var value_6 = NavDisplay$slambda_0(overlayScenes, currentOverlayScenes, null);
        tmp0_0.j31(value_6);
        tmp_10 = value_6;
      } else {
        tmp_10 = it_4;
      }
      var tmp$ret$30 = tmp_10;
      LaunchedEffect(overlayScenes, tmp$ret$30, $composer_0, 0);
      var tmp1_remember$arg$0 = toList(sceneMap.g58_1);
      var tmp2_remember$arg$1 = currentOverlayScenes.s5c();
      var tmp3_remember$arg$2 = zIndices.toString();
      var tmp0_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = !!(!!($composer_0.k31(tmp1_remember$arg$0) | $composer_0.k31(tmp2_remember$arg$1)) | $composer_0.k31(tmp3_remember$arg$2));
      // Inline function 'kotlin.let' call
      var it_5 = tmp0_1.i31();
      var tmp_11;
      if (invalid_1 || it_5 === Companion_getInstance().f30_1) {
        // Inline function 'kotlin.collections.buildMap' call
        // Inline function 'kotlin.collections.buildMapInternal' call
        // Inline function 'kotlin.apply' call
        var this_5 = LinkedHashMap_init_$Create$();
        // Inline function 'kotlin.collections.mutableListOf' call
        var scenes = ArrayList_init_$Create$_0();
        // Inline function 'kotlin.collections.sortedByDescending' call
        var this_6 = sceneMap.g58_1;
        // Inline function 'kotlin.comparisons.compareByDescending' call
        var tmp_12 = NavDisplay$lambda_3(zIndices);
        var tmp$ret$44 = new sam$kotlin_Comparator$0(tmp_12);
        // Inline function 'kotlin.collections.map' call
        var this_7 = sortedWith(this_6, tmp$ret$44);
        // Inline function 'kotlin.collections.mapTo' call
        var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_7, 10));
        var _iterator__ex2g4s_1 = this_7.t();
        while (_iterator__ex2g4s_1.u()) {
          var item_1 = _iterator__ex2g4s_1.v();
          var tmp$ret$47 = item_1.u1();
          destination_1.j1(tmp$ret$47);
        }
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_2 = destination_1.t();
        while (_iterator__ex2g4s_2.u()) {
          var element = _iterator__ex2g4s_2.v();
          if (!scenes.m1(element)) {
            scenes.j1(element);
          }
        }
        var scenesInZOrder = plus(currentOverlayScenes, scenes);
        // Inline function 'kotlin.collections.mutableSetOf' call
        var coveredEntryKeys = LinkedHashSet_init_$Create$();
        var shouldSwapExcludedScenesFromTarget = !equals(transition.o70(), first(scenes));
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var inductionVariable = 0;
        var last = scenesInZOrder.n1() - 1 | 0;
        if (inductionVariable <= last)
          do {
            var index_0 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var item_2 = scenesInZOrder.l1(index_0);
            // Inline function 'kotlin.collections.map' call
            var this_8 = item_2.s1();
            // Inline function 'kotlin.collections.mapTo' call
            var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(this_8, 10));
            var _iterator__ex2g4s_3 = this_8.t();
            while (_iterator__ex2g4s_3.u()) {
              var item_3 = _iterator__ex2g4s_3.v();
              var tmp$ret$55 = item_3.tmu_1;
              destination_2.j1(tmp$ret$55);
            }
            // Inline function 'kotlin.collections.filterNot' call
            // Inline function 'kotlin.collections.filterNotTo' call
            var destination_3 = ArrayList_init_$Create$_0();
            var _iterator__ex2g4s_4 = destination_2.t();
            while (_iterator__ex2g4s_4.u()) {
              var element_0 = _iterator__ex2g4s_4.v();
              if (!coveredEntryKeys.m1(element_0)) {
                destination_3.j1(element_0);
              }
            }
            var newlyCoveredEntryKeys = toSet(destination_3);
            if (shouldSwapExcludedScenesFromTarget && !equals(transition.o70(), item_2)) {
              var tmp_13 = AnimatedSceneKey_init_$Create$(item_2);
              // Inline function 'kotlin.collections.map' call
              var this_9 = transition.o70().s1();
              // Inline function 'kotlin.collections.mapTo' call
              var destination_4 = ArrayList_init_$Create$(collectionSizeOrDefault(this_9, 10));
              var _iterator__ex2g4s_5 = this_9.t();
              while (_iterator__ex2g4s_5.u()) {
                var item_4 = _iterator__ex2g4s_5.v();
                var tmp$ret$61 = item_4.tmu_1;
                destination_4.j1(tmp$ret$61);
              }
              this_5.z2(tmp_13, toSet(destination_4));
            } else {
              this_5.z2(AnimatedSceneKey_init_$Create$(item_2), toMutableSet(coveredEntryKeys));
            }
            coveredEntryKeys.o1(newlyCoveredEntryKeys);
          }
           while (inductionVariable <= last);
        if (shouldSwapExcludedScenesFromTarget) {
          this_5.z2(AnimatedSceneKey_init_$Create$(transition.o70()), emptySet());
        }
        var value_7 = this_5.t5();
        tmp0_1.j31(value_7);
        tmp_11 = value_7;
      } else {
        tmp_11 = it_5;
      }
      var sceneToExcludedEntryMap = tmp_11;
      var tmp_14;
      if (initialZIndex >= targetZIndex) {
        tmp_14 = transition.v70();
      } else {
        tmp_14 = transition.o70();
      }
      var transitionScene = tmp_14;
      if (inPredictiveBack) {
        $composer_0.m30(-2006245323);
        if (!equals(transition.v70(), previousScene)) {
          $composer_0.m30(-2006191693);
          var tmp0_2 = $composer_0;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_2 = !!(!!($composer_0.q31(transitionState) | $composer_0.n31(progress)) | $composer_0.k31(previousScene));
          // Inline function 'kotlin.let' call
          var it_6 = tmp0_2.i31();
          var tmp_15;
          if (invalid_2 || it_6 === Companion_getInstance().f30_1) {
            var value_8 = NavDisplay$slambda_2(transitionState, progress, previousScene, null);
            tmp0_2.j31(value_8);
            tmp_15 = value_8;
          } else {
            tmp_15 = it_6;
          }
          var tmp$ret$62 = tmp_15;
          LaunchedEffect_0(previousScene, progress, tmp$ret$62, $composer_0, 0);
          $composer_0.n30();
        } else {
          $composer_0.m30(-2005987961);
          $composer_0.n30();
        }
        $composer_0.n30();
      } else {
        $composer_0.m30(-2005910120);
        var tmp0_3 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_3 = !!(!!($composer_0.q31(transitionState) | $composer_0.k31(scene)) | $composer_0.k31(transition));
        // Inline function 'kotlin.let' call
        var it_7 = tmp0_3.i31();
        var tmp_16;
        if (invalid_3 || it_7 === Companion_getInstance().f30_1) {
          var value_9 = NavDisplay$slambda_4(transitionState, scene, transition, null);
          tmp0_3.j31(value_9);
          tmp_16 = value_9;
        } else {
          tmp_16 = it_7;
        }
        var tmp$ret$66 = tmp_16;
        LaunchedEffect(scene, tmp$ret$66, $composer_0, 0);
        $composer_0.n30();
      }
      var tmp0_4 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_4 = !!(!!(!!(!!(!!(!!($composer_0.l31(inPredictiveBack) | $composer_0.k31(transitionScene)) | $composer_0.m31(swipeEdge)) | (($dirty & 29360128 ^ 12582912) > 8388608 && $composer_0.k31(predictivePopTransitionSpec_0._v) || ($dirty & 12582912) === 8388608)) | $composer_0.l31(isPop_0)) | (($dirty & 3670016 ^ 1572864) > 1048576 && $composer_0.k31(popTransitionSpec_0._v) || ($dirty & 1572864) === 1048576)) | (($dirty & 458752 ^ 196608) > 131072 && $composer_0.k31(transitionSpec_0._v) || ($dirty & 196608) === 131072));
      // Inline function 'kotlin.let' call
      var it_8 = tmp0_4.i31();
      var tmp_17;
      if (invalid_4 || it_8 === Companion_getInstance().f30_1) {
        var value_10 = NavDisplay$lambda_4(inPredictiveBack, transitionScene, swipeEdge, predictivePopTransitionSpec_0, isPop_0, popTransitionSpec_0, transitionSpec_0);
        tmp0_4.j31(value_10);
        tmp_17 = value_10;
      } else {
        tmp_17 = it_8;
      }
      var contentTransform = tmp_17;
      var animatedContentScope = {_v: null};
      var tmp_18 = modifier_0._v;
      var tmp0_5 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_5 = !!(!!($composer_0.k31(contentTransform) | $composer_0.n31(targetZIndex)) | $composer_0.q31(sizeTransform_0._v));
      // Inline function 'kotlin.let' call
      var it_9 = tmp0_5.i31();
      var tmp_19;
      if (invalid_5 || it_9 === Companion_getInstance().f30_1) {
        var value_11 = NavDisplay$lambda_5(contentTransform, targetZIndex, sizeTransform_0);
        tmp0_5.j31(value_11);
        tmp_19 = value_11;
      } else {
        tmp_19 = it_9;
      }
      var tmp_20 = tmp_19;
      var tmp_21 = contentAlignment_0._v;
      // Inline function 'androidx.compose.runtime.cache' call
      var this_10 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_10 = this_10.i31();
      var tmp_22;
      if (false || it_10 === Companion_getInstance().f30_1) {
        var value_12 = NavDisplay$lambda_6;
        this_10.j31(value_12);
        tmp_22 = value_12;
      } else {
        tmp_22 = it_10;
      }
      var tmp_23 = tmp_22;
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-1167420988, true, NavDisplay$lambda_7(transition, currentOverlayScenes, animatedContentScope, sceneToExcludedEntryMap), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_6 = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it_11 = $composer_1.i31();
      var tmp_24;
      if (invalid_6 || it_11 === Companion_getInstance().f30_1) {
        var value_13 = ComposableLambda$invoke$ref_4(dispatchReceiver);
        $composer_1.j31(value_13);
        tmp_24 = value_13;
      } else {
        tmp_24 = it_11;
      }
      var tmp$ret$82 = tmp_24;
      AnimatedContent(transition, tmp_18, tmp_20, tmp_21, tmp_23, tmp$ret$82, $composer_0, 221184 | 112 & $dirty >> 3 | 7168 & $dirty, 0);
      var tmp0_6 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_7 = !!($composer_0.k31(transition) | $composer_0.q31(zIndices));
      // Inline function 'kotlin.let' call
      var it_12 = tmp0_6.i31();
      var tmp_25;
      if (invalid_7 || it_12 === Companion_getInstance().f30_1) {
        var value_14 = NavDisplay$slambda_6(transition, sceneMap, zIndices, null);
        tmp0_6.j31(value_14);
        tmp_25 = value_14;
      } else {
        tmp_25 = it_12;
      }
      var tmp$ret$89 = tmp_25;
      LaunchedEffect(transition, tmp$ret$89, $composer_0, 0);
      // Inline function 'androidx.compose.ui.util.fastForEachReversed' call
      var inductionVariable_0 = currentOverlayScenes.n1() - 1 | 0;
      if (0 <= inductionVariable_0)
        do {
          var index_1 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + -1 | 0;
          var item_5 = currentOverlayScenes.l1(index_1);
          // Inline function 'androidx.compose.runtime.rememberCoroutineScope' call
          var getContext = null;
          var $composer_2 = $composer_0;
          if (!((1 & 1) === 0)) {
            getContext = NavDisplay$lambda_8;
          }
          var composer = $composer_2;
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_13 = $composer_2.i31();
          var tmp_26;
          if (false || it_13 === Companion_getInstance().f30_1) {
            var value_15 = createCompositionCoroutineScope(getContext(), composer);
            $composer_2.j31(value_15);
            tmp_26 = value_15;
          } else {
            tmp_26 = it_13;
          }
          var scope = tmp_26;
          $composer_0.o30(43488072, item_5);
          var tmp_27 = equals(firstOrNull(overlayScenes), item_5) ? State_RESUMED_getInstance() : State_STARTED_getInstance();
          var overlaySceneLifecycleOwner = rememberLifecycleOwner(tmp_27, null, $composer_0, 0, 2);
          var tmp_28 = get_LocalLifecycleOwner().h3c(overlaySceneLifecycleOwner);
          var tmp_29 = get_LocalEntriesToExcludeFromCurrentScene().h3c(getValue(sceneToExcludedEntryMap, AnimatedSceneKey_init_$Create$(item_5)));
          var tmp_30 = get_LocalCurrentScene().h3c(item_5);
          var tmp_31 = get_LocalNavAnimatedContentScope();
          var tmp_32;
          if (animatedContentScope._v == null) {
            throwUninitializedPropertyAccessException('animatedContentScope');
          } else {
            tmp_32 = animatedContentScope._v;
          }
          var tmp_33 = [tmp_28, tmp_29, tmp_30, tmp_31.h3c(tmp_32)];
          // Inline function 'kotlin.run' call
          var dispatchReceiver_0 = rememberComposableLambda(-1656080439, true, NavDisplay$lambda_9(item_5), $composer_0, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_3 = $composer_0;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_8 = $composer_3.k31(dispatchReceiver_0);
          // Inline function 'kotlin.let' call
          var it_14 = $composer_3.i31();
          var tmp_34;
          if (invalid_8 || it_14 === Companion_getInstance().f30_1) {
            var value_16 = ComposableLambda$invoke$ref(dispatchReceiver_0);
            $composer_3.j31(value_16);
            tmp_34 = value_16;
          } else {
            tmp_34 = it_14;
          }
          var tmp$ret$100 = tmp_34;
          CompositionLocalProvider_0(tmp_33, tmp$ret$100, $composer_0, 48 | androidx_compose_runtime_ProvidedValue$stableprop_getter());
          $composer_0.p30();
          if (!overlayScenes.m1(item_5)) {
            $composer_0.m30(1349069968);
            var tmp0_7 = $composer_0;
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_9 = $composer_0.k31(item_5);
            // Inline function 'kotlin.let' call
            var it_15 = tmp0_7.i31();
            var tmp_35;
            if (invalid_9 || it_15 === Companion_getInstance().f30_1) {
              var value_17 = NavDisplay$slambda_8(item_5, currentOverlayScenes, null);
              tmp0_7.j31(value_17);
              tmp_35 = value_17;
            } else {
              tmp_35 = it_15;
            }
            var tmp$ret$107 = tmp_35;
            launch(scope, VOID, VOID, tmp$ret$107);
            $composer_0.n30();
          } else {
            $composer_0.m30(1349214118);
            $composer_0.n30();
          }
        }
         while (0 <= inductionVariable_0);
    } else {
      $composer_0.z30();
    }
    var tmp4_safe_receiver = $composer_0.t30();
    if (tmp4_safe_receiver == null)
      null;
    else {
      tmp4_safe_receiver.p3c(NavDisplay$lambda_10(sceneState, navigationEventState, modifier_0, contentAlignment_0, sizeTransform_0, transitionSpec_0, popTransitionSpec_0, predictivePopTransitionSpec_0, $changed, $default));
    }
  }
  function isPop(oldBackStack, newBackStack) {
    if (!equals(first(oldBackStack), first(newBackStack)))
      return false;
    if (newBackStack.n1() > oldBackStack.n1())
      return false;
    var tmp0 = get_indices(newBackStack);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = tmp0.x1_1;
      var last = tmp0.y1_1;
      if (inductionVariable <= last)
        do {
          var element = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var index = element;
          if (!equals(newBackStack.l1(index), oldBackStack.l1(index))) {
            tmp$ret$0 = element;
            break $l$block;
          }
        }
         while (!(element === last));
      tmp$ret$0 = null;
    }
    var divergingIndex = tmp$ret$0;
    return divergingIndex == null && !(newBackStack.n1() === oldBackStack.n1());
  }
  function AnimatedSceneKey_init_$Init$(scene, $this) {
    AnimatedSceneKey.call($this, getKClassFromExpression(scene), scene.t1());
    return $this;
  }
  function AnimatedSceneKey_init_$Create$(scene) {
    return AnimatedSceneKey_init_$Init$(scene, objectCreate(protoOf(AnimatedSceneKey)));
  }
  function AnimatedSceneKey(clazz, key) {
    this.wxq_1 = clazz;
    this.xxq_1 = key;
  }
  protoOf(AnimatedSceneKey).toString = function () {
    return 'AnimatedSceneKey(clazz=' + toString(this.wxq_1) + ', key=' + toString(this.xxq_1) + ')';
  };
  protoOf(AnimatedSceneKey).hashCode = function () {
    var result = this.wxq_1.hashCode();
    result = imul(result, 31) + hashCode(this.xxq_1) | 0;
    return result;
  };
  protoOf(AnimatedSceneKey).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AnimatedSceneKey))
      return false;
    if (!this.wxq_1.equals(other.wxq_1))
      return false;
    if (!equals(this.xxq_1, other.xxq_1))
      return false;
    return true;
  };
  function predictivePopSpec(_this__u8e3s4) {
    var tmp = get(_this__u8e3s4.exq(), PredictivePopTransitionKey_instance);
    return (!(tmp == null) ? typeof tmp === 'function' : false) ? tmp : null;
  }
  function contentTransform(_this__u8e3s4, key) {
    var tmp = get(_this__u8e3s4.exq(), key);
    return (!(tmp == null) ? typeof tmp === 'function' : false) ? tmp : null;
  }
  function TransitionKey() {
  }
  var TransitionKey_instance;
  function TransitionKey_getInstance() {
    return TransitionKey_instance;
  }
  function PopTransitionKey() {
  }
  var PopTransitionKey_instance;
  function PopTransitionKey_getInstance() {
    return PopTransitionKey_instance;
  }
  function PredictivePopTransitionKey() {
  }
  var PredictivePopTransitionKey_instance;
  function PredictivePopTransitionKey_getInstance() {
    return PredictivePopTransitionKey_instance;
  }
  function sam$kotlin_Comparator$0(function_0) {
    this.yxq_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0).ze = function (a, b) {
    return this.yxq_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
    return this.ze(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).q3 = function () {
    return this.yxq_1;
  };
  protoOf(sam$kotlin_Comparator$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function NavDisplay$lambda($backStack) {
    return function () {
      var tmp;
      if (isInterface($backStack, KtMutableList)) {
        removeLastOrNull($backStack);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function NavDisplay$lambda_0($backStack, $modifier, $contentAlignment, $onBack, $entryDecorators, $sceneStrategies, $sceneDecoratorStrategies, $sharedTransitionScope, $sizeTransform, $transitionSpec, $popTransitionSpec, $predictivePopTransitionSpec, $entryProvider, $$changed, $$changed1, $$default) {
    return function ($composer, $force) {
      NavDisplay($backStack, $modifier._v, $contentAlignment._v, $onBack._v, $entryDecorators._v, $sceneStrategies._v, $sceneDecoratorStrategies._v, $sharedTransitionScope._v, $sizeTransform._v, $transitionSpec._v, $popTransitionSpec._v, $predictivePopTransitionSpec._v, $entryProvider, $composer, updateChangedFlags($$changed | 1), updateChangedFlags($$changed1), $$default);
      return Unit_instance;
    };
  }
  function NavDisplay$lambda_1($entries, $scene, $onBack) {
    return function () {
      // Inline function 'kotlin.repeat' call
      var times = $entries.n1() - $scene.dxq().n1() | 0;
      var inductionVariable = 0;
      if (inductionVariable < times)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          $onBack();
        }
         while (inductionVariable < times);
      return Unit_instance;
    };
  }
  function NavDisplay$lambda_2($entries, $modifier, $contentAlignment, $sceneStrategies, $sceneDecoratorStrategies, $sharedTransitionScope, $sizeTransform, $transitionSpec, $popTransitionSpec, $predictivePopTransitionSpec, $onBack, $$changed, $$changed1, $$default) {
    return function ($composer, $force) {
      NavDisplay_0($entries, $modifier._v, $contentAlignment._v, $sceneStrategies._v, $sceneDecoratorStrategies._v, $sharedTransitionScope._v, $sizeTransform._v, $transitionSpec._v, $popTransitionSpec._v, $predictivePopTransitionSpec._v, $onBack, $composer, updateChangedFlags($$changed | 1), updateChangedFlags($$changed1), $$default);
      return Unit_instance;
    };
  }
  function NavDisplay$slambda($overlayScenes, $currentOverlayScenes, resultContinuation) {
    this.hxr_1 = $overlayScenes;
    this.ixr_1 = $currentOverlayScenes;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(NavDisplay$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(NavDisplay$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(NavDisplay$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var this_0 = this.hxr_1;
          var inductionVariable = 0;
          var last = this_0.n1() - 1 | 0;
          if (inductionVariable <= last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var item = this_0.l1(index);
              if (!this.ixr_1.lh(item)) {
                this.ixr_1.zz(item);
              }
            }
             while (inductionVariable <= last);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(NavDisplay$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new NavDisplay$slambda(this.hxr_1, this.ixr_1, completion);
    i.jxr_1 = $this$LaunchedEffect;
    return i;
  };
  function NavDisplay$slambda_0($overlayScenes, $currentOverlayScenes, resultContinuation) {
    var i = new NavDisplay$slambda($overlayScenes, $currentOverlayScenes, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function NavDisplay$lambda_3($zIndices) {
    return function (a, b) {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp = $zIndices.w2(b.t1());
      var tmp$ret$2 = $zIndices.w2(a.t1());
      return compareValues(tmp, tmp$ret$2);
    };
  }
  function NavDisplay$slambda_1($transitionState, $progress, $previousScene, resultContinuation) {
    this.sxr_1 = $transitionState;
    this.txr_1 = $progress;
    this.uxr_1 = $previousScene;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(NavDisplay$slambda_1).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(NavDisplay$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(NavDisplay$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.sxr_1.eey(this.txr_1, this.uxr_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(NavDisplay$slambda_1).q24 = function ($this$LaunchedEffect, completion) {
    var i = new NavDisplay$slambda_1(this.sxr_1, this.txr_1, this.uxr_1, completion);
    i.vxr_1 = $this$LaunchedEffect;
    return i;
  };
  function NavDisplay$slambda_2($transitionState, $progress, $previousScene, resultContinuation) {
    var i = new NavDisplay$slambda_1($transitionState, $progress, $previousScene, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function NavDisplay$slambda$lambda$slambda($value, $finalFraction, $transitionState, $scene, resultContinuation) {
    this.exs_1 = $value;
    this.fxs_1 = $finalFraction;
    this.gxs_1 = $transitionState;
    this.hxs_1 = $scene;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(NavDisplay$slambda$lambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(NavDisplay$slambda$lambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(NavDisplay$slambda$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            if (!(this.exs_1 === this.fxs_1)) {
              this.n9_1 = 1;
              suspendResult = this.gxs_1.fey(this.exs_1, VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            if (this.exs_1 === this.fxs_1) {
              this.n9_1 = 3;
              suspendResult = this.gxs_1.dey(this.hxs_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 4;
              continue $sm;
            }

          case 3:
            this.n9_1 = 4;
            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(NavDisplay$slambda$lambda$slambda).q24 = function ($this$launch, completion) {
    var i = new NavDisplay$slambda$lambda$slambda(this.exs_1, this.fxs_1, this.gxs_1, this.hxs_1, completion);
    i.ixs_1 = $this$launch;
    return i;
  };
  function NavDisplay$slambda$lambda$slambda_0($value, $finalFraction, $transitionState, $scene, resultContinuation) {
    var i = new NavDisplay$slambda$lambda$slambda($value, $finalFraction, $transitionState, $scene, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function NavDisplay$slambda$lambda($this_LaunchedEffect, $finalFraction, $transitionState, $scene) {
    return function (value, _unused_var__etf5q3) {
      launch($this_LaunchedEffect, VOID, VOID, NavDisplay$slambda$lambda$slambda_0(value, $finalFraction, $transitionState, $scene, null));
      return Unit_instance;
    };
  }
  function NavDisplay$slambda_3($transitionState, $scene, $transition, resultContinuation) {
    this.rxs_1 = $transitionState;
    this.sxs_1 = $scene;
    this.txs_1 = $transition;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(NavDisplay$slambda_3).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(NavDisplay$slambda_3).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(NavDisplay$slambda_3).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            if (!equals(this.rxs_1.v70(), this.sxs_1)) {
              this.n9_1 = 2;
              suspendResult = this.rxs_1.hey(this.sxs_1, VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var this_0 = this.txs_1.ber();
              var totalDuration = divide(this_0, fromInt(1000000));
              var predictiveBackCompleted = equals(this.txs_1.o70(), this.sxs_1);
              var tmp_0;
              if (predictiveBackCompleted) {
                tmp_0 = to(1.0, numberToInt((1.0 - this.rxs_1.veu()) * toNumber(totalDuration)));
              } else {
                tmp_0 = to(0.0, numberToInt(this.rxs_1.veu() * toNumber(totalDuration)));
              }
              var _destruct__k2r9zo = tmp_0;
              var finalFraction = _destruct__k2r9zo.zh();
              var remainingDuration = _destruct__k2r9zo.ai();
              this.n9_1 = 1;
              var tmp_1 = this.rxs_1.veu();
              var tmp_2 = tween(remainingDuration);
              suspendResult = animate(tmp_1, finalFraction, VOID, tmp_2, NavDisplay$slambda$lambda(this.uxs_1, finalFraction, this.rxs_1, this.sxs_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.n9_1 = 3;
            continue $sm;
          case 2:
            this.n9_1 = 3;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(NavDisplay$slambda_3).q24 = function ($this$LaunchedEffect, completion) {
    var i = new NavDisplay$slambda_3(this.rxs_1, this.sxs_1, this.txs_1, completion);
    i.uxs_1 = $this$LaunchedEffect;
    return i;
  };
  function NavDisplay$slambda_4($transitionState, $scene, $transition, resultContinuation) {
    var i = new NavDisplay$slambda_3($transitionState, $scene, $transition, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function NavDisplay$lambda_4($inPredictiveBack, $transitionScene, $swipeEdge, $predictivePopTransitionSpec, $isPop, $popTransitionSpec, $transitionSpec) {
    return function (_this__u8e3s4) {
      var tmp;
      if ($inPredictiveBack) {
        var tmp0_safe_receiver = predictivePopSpec($transitionScene);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver(_this__u8e3s4, $swipeEdge);
        tmp = tmp1_elvis_lhs == null ? $predictivePopTransitionSpec._v(_this__u8e3s4, $swipeEdge) : tmp1_elvis_lhs;
      } else if ($isPop) {
        var tmp2_safe_receiver = contentTransform($transitionScene, PopTransitionKey_instance);
        var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver(_this__u8e3s4);
        tmp = tmp3_elvis_lhs == null ? $popTransitionSpec._v(_this__u8e3s4) : tmp3_elvis_lhs;
      } else {
        var tmp4_safe_receiver = contentTransform($transitionScene, TransitionKey_instance);
        var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver(_this__u8e3s4);
        tmp = tmp5_elvis_lhs == null ? $transitionSpec._v(_this__u8e3s4) : tmp5_elvis_lhs;
      }
      return tmp;
    };
  }
  function NavDisplay$lambda_5($contentTransform, $targetZIndex, $sizeTransform) {
    return function ($this$AnimatedContent) {
      return new ContentTransform($contentTransform($this$AnimatedContent).hf1_1, $contentTransform($this$AnimatedContent).if1_1, $targetZIndex, $sizeTransform._v);
    };
  }
  function NavDisplay$lambda_6(scene) {
    return AnimatedSceneKey_init_$Create$(scene);
  }
  function NavDisplay$lambda$lambda($targetScene) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        tmp = $targetScene.rj3()($composer_0, 0);
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function NavDisplay$lambda_7($transition, $currentOverlayScenes, $animatedContentScope, $sceneToExcludedEntryMap) {
    return function ($this$AnimatedContent, targetScene, $composer, $changed) {
      var $composer_0 = $composer;
      var isSettled = equals($transition.v70(), $transition.o70());
      var tmp = isSettled && $currentOverlayScenes.r() ? State_RESUMED_getInstance() : State_STARTED_getInstance();
      var sceneLifecycleOwner = rememberLifecycleOwner(tmp, null, $composer_0, 0, 2);
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it = $composer_0.i31();
      var tmp_0;
      if (false || it === Companion_getInstance().f30_1) {
        var value = $this$AnimatedContent;
        $composer_0.j31(value);
        tmp_0 = value;
      } else {
        tmp_0 = it;
      }
      var tmp$ret$0 = tmp_0;
      $animatedContentScope._v = tmp$ret$0;
      var tmp_1 = get_LocalLifecycleOwner().h3c(sceneLifecycleOwner);
      var tmp_2 = get_LocalNavAnimatedContentScope();
      var tmp_3;
      if ($animatedContentScope._v == null) {
        throwUninitializedPropertyAccessException('animatedContentScope');
      } else {
        tmp_3 = $animatedContentScope._v;
      }
      var tmp_4 = [tmp_1, tmp_2.h3c(tmp_3), get_LocalCurrentScene().h3c(targetScene), get_LocalEntriesToExcludeFromCurrentScene().h3c(getValue($sceneToExcludedEntryMap, AnimatedSceneKey_init_$Create$(targetScene)))];
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-1734941436, true, NavDisplay$lambda$lambda(targetScene), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it_0 = $composer_1.i31();
      var tmp_5;
      if (invalid || it_0 === Companion_getInstance().f30_1) {
        var value_0 = ComposableLambda$invoke$ref(dispatchReceiver);
        $composer_1.j31(value_0);
        tmp_5 = value_0;
      } else {
        tmp_5 = it_0;
      }
      var tmp$ret$4 = tmp_5;
      CompositionLocalProvider_0(tmp_4, tmp$ret$4, $composer_0, 48 | androidx_compose_runtime_ProvidedValue$stableprop_getter());
      return Unit_instance;
    };
  }
  function ComposableLambda$invoke$ref_4(p0) {
    return constructCallableReference(function (p0_0, p1, p2, p3) {
      p0.v50(p0_0, p1, p2, p3);
      return Unit_instance;
    }, 4, 0, 255, VOID, [p0]);
  }
  function NavDisplay$slambda$o$collect$slambda($$this$unsafeFlow, resultContinuation) {
    this.dxt_1 = $$this$unsafeFlow;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(NavDisplay$slambda$o$collect$slambda).o2k = function (value, $completion) {
    var tmp = this.p2k(value, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(NavDisplay$slambda$o$collect$slambda).ja = function (p1, $completion) {
    return this.o2k(p1, $completion);
  };
  protoOf(NavDisplay$slambda$o$collect$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.gxt_1 = this.dxt_1;
            this.fxt_1 = this.ext_1;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            var $this$transform = this.gxt_1;
            var value = this.fxt_1;
            if (!value) {
              this.n9_1 = 3;
              suspendResult = $this$transform.a1v(value, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 2:
            if (false) {
              this.n9_1 = 1;
              continue $sm;
            }

            this.n9_1 = 4;
            continue $sm;
          case 3:
            this.n9_1 = 4;
            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(NavDisplay$slambda$o$collect$slambda).p2k = function (value, completion) {
    var i = new NavDisplay$slambda$o$collect$slambda(this.dxt_1, completion);
    i.ext_1 = value;
    return i;
  };
  function NavDisplay$slambda$o$collect$slambda_0($$this$unsafeFlow, resultContinuation) {
    var i = new NavDisplay$slambda$o$collect$slambda($$this$unsafeFlow, resultContinuation);
    return constructCallableReference(function (value, $completion) {
      return i.o2k(value, $completion);
    }, 1);
  }
  function $collectCOROUTINE$(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.pxt_1 = _this__u8e3s4;
    this.qxt_1 = collector;
  }
  protoOf($collectCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var $this$unsafeFlow = this.qxt_1;
            this.n9_1 = 1;
            var tmp_0 = NavDisplay$slambda$o$collect$slambda_0($this$unsafeFlow, null);
            suspendResult = this.pxt_1.rxt_1.l1u(new sam$kotlinx_coroutines_flow_FlowCollector$0(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function sam$kotlinx_coroutines_flow_FlowCollector$0(function_0) {
    this.sxt_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).a1v = function (value, $completion) {
    return this.sxt_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).q3 = function () {
    return this.sxt_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function NavDisplay$slambda$lambda_0($transition) {
    return function () {
      return $transition.rea();
    };
  }
  function NavDisplay$$inlined$cache$10$2($this) {
    this.rxt_1 = $this;
  }
  protoOf(NavDisplay$$inlined$cache$10$2).b1v = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$(this, collector, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(NavDisplay$$inlined$cache$10$2).l1u = function (collector, $completion) {
    return this.b1v(collector, $completion);
  };
  function NavDisplay$slambda$slambda($transition, $sceneMap, $zIndices, resultContinuation) {
    this.bxu_1 = $transition;
    this.cxu_1 = $sceneMap;
    this.dxu_1 = $zIndices;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(NavDisplay$slambda$slambda).xf4 = function (it, $completion) {
    var tmp = this.yf4(it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(NavDisplay$slambda$slambda).ja = function (p1, $completion) {
    return this.xf4((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(NavDisplay$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var targetKey = AnimatedSceneKey_init_$Create$(this.bxu_1.o70());
          var _iterator__ex2g4s = toList(this.cxu_1.h58_1).t();
          while (_iterator__ex2g4s.u()) {
            var element = _iterator__ex2g4s.v();
            if (!element.equals(targetKey)) {
              this.cxu_1.a3(element);
            }
          }
          var this_0 = this.dxu_1;
          l$ret$1: do {
            var m = this_0.qy_1;
            var lastIndex = m.length - 2 | 0;
            var inductionVariable = 0;
            if (inductionVariable <= lastIndex)
              do {
                var i = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var slot = m[i];
                var this_1 = slot;
                if (!equalsLong(bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144)), new Long(-2139062144, -2139062144))) {
                  var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
                  var inductionVariable_0 = 0;
                  if (inductionVariable_0 < bitCount)
                    do {
                      var j = inductionVariable_0;
                      inductionVariable_0 = inductionVariable_0 + 1 | 0;
                      var value = bitwiseAnd(slot, new Long(255, 0));
                      if (compare(value, new Long(128, 0)) < 0) {
                        var index = (i << 3) + j | 0;
                        var tmp0 = this_0.ry_1[index];
                        this_0.sy_1[index];
                        if (!tmp0.equals(targetKey)) {
                          this_0.cv(index);
                        }
                      }
                      slot = shiftRight(slot, 8);
                    }
                     while (inductionVariable_0 < bitCount);
                  if (!(bitCount === 8)) {
                    break l$ret$1;
                  }
                }
              }
               while (!(i === lastIndex));
          }
           while (false);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(NavDisplay$slambda$slambda).yf4 = function (it, completion) {
    var i = new NavDisplay$slambda$slambda(this.bxu_1, this.cxu_1, this.dxu_1, completion);
    i.exu_1 = it;
    return i;
  };
  function NavDisplay$slambda$slambda_0($transition, $sceneMap, $zIndices, resultContinuation) {
    var i = new NavDisplay$slambda$slambda($transition, $sceneMap, $zIndices, resultContinuation);
    return constructCallableReference(function (it, $completion) {
      return i.xf4(it, $completion);
    }, 1);
  }
  function NavDisplay$slambda_5($transition, $sceneMap, $zIndices, resultContinuation) {
    this.nxu_1 = $transition;
    this.oxu_1 = $sceneMap;
    this.pxu_1 = $zIndices;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(NavDisplay$slambda_5).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(NavDisplay$slambda_5).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(NavDisplay$slambda_5).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var this_0 = snapshotFlow(NavDisplay$slambda$lambda_0(this.nxu_1));
            var tmp_0 = new NavDisplay$$inlined$cache$10$2(this_0);
            var tmp_1 = NavDisplay$slambda$slambda_0(this.nxu_1, this.oxu_1, this.pxu_1, null);
            suspendResult = tmp_0.l1u(new sam$kotlinx_coroutines_flow_FlowCollector$0(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(NavDisplay$slambda_5).q24 = function ($this$LaunchedEffect, completion) {
    var i = new NavDisplay$slambda_5(this.nxu_1, this.oxu_1, this.pxu_1, completion);
    i.qxu_1 = $this$LaunchedEffect;
    return i;
  };
  function NavDisplay$slambda_6($transition, $sceneMap, $zIndices, resultContinuation) {
    var i = new NavDisplay$slambda_5($transition, $sceneMap, $zIndices, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function NavDisplay$lambda_8() {
    return EmptyCoroutineContext_getInstance();
  }
  function NavDisplay$lambda_9($overlayScene) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        tmp = $overlayScene.rj3()($composer_0, 0);
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function NavDisplay$slambda_7($overlayScene, $currentOverlayScenes, resultContinuation) {
    this.zxu_1 = $overlayScene;
    this.axv_1 = $currentOverlayScenes;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(NavDisplay$slambda_7).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(NavDisplay$slambda_7).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(NavDisplay$slambda_7).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.zxu_1.cxq(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.axv_1.g10(this.zxu_1);
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(NavDisplay$slambda_7).q24 = function ($this$launch, completion) {
    var i = new NavDisplay$slambda_7(this.zxu_1, this.axv_1, completion);
    i.bxv_1 = $this$launch;
    return i;
  };
  function NavDisplay$slambda_8($overlayScene, $currentOverlayScenes, resultContinuation) {
    var i = new NavDisplay$slambda_7($overlayScene, $currentOverlayScenes, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function NavDisplay$lambda_10($sceneState, $navigationEventState, $modifier, $contentAlignment, $sizeTransform, $transitionSpec, $popTransitionSpec, $predictivePopTransitionSpec, $$changed, $$default) {
    return function ($composer, $force) {
      NavDisplay_1($sceneState, $navigationEventState, $modifier._v, $contentAlignment._v, $sizeTransform._v, $transitionSpec._v, $popTransitionSpec._v, $predictivePopTransitionSpec._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function defaultTransitionSpec() {
    return defaultTransitionSpec$lambda;
  }
  function defaultPopTransitionSpec() {
    return defaultPopTransitionSpec$lambda;
  }
  function defaultPredictivePopTransitionSpec() {
    return defaultPredictivePopTransitionSpec$lambda;
  }
  function defaultTransitionSpec$lambda(_this__u8e3s4) {
    return new ContentTransform(Companion_getInstance_2().nf5_1, Companion_getInstance_3().ff4_1);
  }
  function defaultPopTransitionSpec$lambda(_this__u8e3s4) {
    return new ContentTransform(Companion_getInstance_2().nf5_1, Companion_getInstance_3().ff4_1);
  }
  function defaultPredictivePopTransitionSpec$lambda(_this__u8e3s4, it) {
    return new ContentTransform(Companion_getInstance_2().nf5_1, Companion_getInstance_3().ff4_1);
  }
  //region block: post-declaration
  protoOf(SinglePaneScene).exq = get_metadata;
  //endregion
  //region block: init
  androidx_navigation3_scene_DialogScene$stable = 0;
  androidx_navigation3_scene_DialogSceneStrategy_Companion_DialogKey$stable = 0;
  androidx_navigation3_scene_DialogSceneStrategy$stable = 0;
  androidx_navigation3_scene_SceneDecoratorStrategyScope$stable = 0;
  androidx_navigation3_scene_SceneInfo$stable = 0;
  androidx_navigation3_scene_SceneState$stable = 0;
  androidx_navigation3_scene_SceneStrategyScope$stable = 0;
  androidx_navigation3_scene_SinglePaneScene$stable = 0;
  androidx_navigation3_scene_SinglePaneSceneStrategy$stable = 0;
  androidx_navigation3_ui_NavDisplay_TransitionKey$stable = 0;
  androidx_navigation3_ui_NavDisplay_PopTransitionKey$stable = 0;
  androidx_navigation3_ui_NavDisplay_PredictivePopTransitionKey$stable = 0;
  androidx_navigation3_ui_NavDisplay$stable = 0;
  androidx_navigation3_ui_AnimatedSceneKey$stable = 8;
  TransitionKey_instance = new TransitionKey();
  PopTransitionKey_instance = new PopTransitionKey();
  PredictivePopTransitionKey_instance = new PredictivePopTransitionKey();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = NavDisplay;
  //endregion
  return _;
}));

//# sourceMappingURL=compose-multiplatform-core-navigation3-navigation3-ui.js.map
